<template>
  <div id="reservationsComponent">
    <page-title
      :heading="heading"
      :subheading="subheading"
      :icon="icon"
    ></page-title>
    <v-container>
      <v-layout class="mb-2" row wrap>
        <v-spacer></v-spacer>
        <!-- <v-text-field
          v-model="expenseSearch"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search">
        </v-text-field> -->
        <v-dialog v-if="hasPermission()" v-model="dialog" max-width="600px" persistent>
          <!-- <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              round
              outline
              v-on="on">
              <v-icon left>attach_money</v-icon>
              {{ $t('expenses.reservations.add') }}
            </v-btn>
          </template> -->
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">
                {{ formTitle }}
              </h2>
            </v-toolbar>
            <v-card-text>
              <v-form lazy-validation ref="formExpense" v-model="valid">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md6>
                      <v-menu v-model="start" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field clearable required :rules="rules.required" :error-messages="errors.start_date" v-model="editedItem.start_date" :label="$t('general.startDate')" prepend-icon="event" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker color="primary" :locale="$t('general.locale')" v-model="editedItem.start_date" @input="start = false"></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-menu v-model="end" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field clearable required :rules="rules.required" v-model="editedItem.end_date" :error-messages="errors.end_date" :label="$t('general.endDate')" prepend-icon="event" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker color="primary" :locale="$t('general.locale')" v-model="editedItem.end_date" @input="end = false"></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-autocomplete v-if="tabActive === 0" v-model="editedItem.user" required :rules="rules.required" :error-messages="errors.user_id" :label="$t('general.employee')" :items="employeesFilter" @change="changeTypeByEmployee(editedItem.user)" item-text="name" return-object></v-autocomplete>
                      <v-text-field v-else v-model="editedItem.user.name" required :rules="rules.required" :error-messages="errors.user_id" :label="$t('general.employee')"></v-text-field>
                    </v-flex>
                    <v-flex xs8 sm8 md8>
                      <v-autocomplete v-model="editedItem.project_id" required :rules="rules.required" :error-messages="errors.project_id" :label="$t('general.project')" :items="projects" item-value="id" item-text="name"></v-autocomplete>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                      <v-checkbox v-if="hasMultiProjects" v-model="selectMultiProject" :disabled="editable" :error-messages="errors.has_request" :label="$t('general.multiProjects')"> </v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-autocomplete v-if="hasMultiProjects && selectMultiProject" v-model="editedItem.project_list" multiple :error-messages="errors.project_id" :label="$t('general.projectSecond')" :items="projectsSecond" item-value="id" item-text="name"></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-text-field clearable required :rules="rules.required" :error-messages="errors.description" :label="$t('general.description')" v-model="editedItem.description"></v-text-field>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                      <v-radio-group v-model="type" row>
                        <v-flex v-if="viewAmexCard(editedItem.user.small_box)" md12>
                          <v-radio :disabled="isDisabledAmexCard" :label="$t('pettyCash.amexCard')" value="amexCard"></v-radio>
                        </v-flex>
                        <v-flex v-if="viewPettyCash(editedItem.user.small_box)" md12>
                          <v-radio :disabled="isDisabledPettyCash" :label="$t('pettyCash.pettyCash')" value="pettyCash"></v-radio>
                        </v-flex>
                        <v-flex md12>
                          <v-radio :disabled="isDisabledAdvance" :label="$t('general.advance')" value="advance"></v-radio>
                        </v-flex>
                        <v-flex md12>
                          <v-radio :disabled="isDisabledRefund" :label="$t('general.refund')" value="refund"></v-radio>
                        </v-flex>
                        <v-flex md12>
                          <v-radio :disabled="isDisabledOkBlue || isDisabledOkBlueEdit" :label="$t('general.okBlue')" value="okBlue"></v-radio>
                        </v-flex>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs8 sm8 md8>
                      <div class="d-flex align-center">
                        <v-checkbox v-if="type === 'pettyCash' || type === 'amexCard'" v-model="editedItem.isVoucherAmount" @change="viewVoucherAmountCheck" :disabled="isDisabledOkBlue" :label="$t('general.okBlue')"> </v-checkbox>
                        <v-text-field v-if="type === 'advance'" v-model.number="editedItem.advance" :disabled="editable || isPettyCash" clearable required prepend-icon="attach_money" type="number" :rules="rules.digit" :persistent-hint="true" :label="$t('general.advance') + $t('general.optionalField')"></v-text-field>
                        <v-text-field v-if="type === 'okBlue' || viewVoucherAmount" v-model.number="editedItem.voucher_amount" :disabled="isDisabledOkBlue" prepend-icon="attach_money" type="number" required :rules="rules.digit" :label="$t('general.voucherAmount')"></v-text-field>
                      </div>
                      <v-alert v-if="type === 'pettyCash' && (editedItem.user && editedItem.user.small_box !== null)" icon="monetization_on" :value="true" color="primary" outline >
                          <h3 class="mb-0">
                            <span class="font-weight-black">{{$t('pettyCash.balanceIn')}} {{ $t('pettyCash.pettyCash') }}:</span>
                              {{ getPettyCashAmount(editedItem.user.small_box) | formatCurrency }}
                          </h3>
                      </v-alert>
                      <v-alert v-if="type === 'amexCard' && (editedItem.user && editedItem.user.small_box !== null)" icon="monetization_on" :value="true" color="primary" outline >
                          <h3 class="mb-0">
                            <span class="font-weight-black">{{$t('pettyCash.balanceIn')}} {{ $t('pettyCash.amexCard') }}:</span>
                              {{ getAmexAmount(editedItem.user.small_box) | formatCurrency }}
                          </h3>
                      </v-alert>
                    </v-flex>
                    <!--<v-flex xs6 sm6 md6>
                          <v-text-field v-if="type === 'advance'" :disabled="editable || isPettyCash" clearable required prepend-icon="attach_money" :rules="rules.digit" :persistent-hint="true" :label="$t('general.advance') + $t('general.optionalField')" v-model="editedItem.advance"></v-text-field>
                          <v-text-field v-if="type === 'okBlue'" :disabled="editable || isPettyCash" clearable required prepend-icon="attach_money" type="number" :rules="rules.required" :persistent-hint="true" :label="$t('general.voucherAmount')" v-model.number="editedItem.voucher_amount"></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                          <v-text-field clearable required :error-messages="errors.advance" prepend-icon="attach_money" :persistent-hint="true" :rules="rules.required && rules.decimal" :label="$t('general.advance')" v-model="editedItem.advance"></v-text-field>
                        </v-flex>-->
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" round flat @click="close">
                {{ $t('general.cancel') }}
              </v-btn>
              <v-btn @click="saveValidate" color="primary" round depressed :loading="loading" :disabled="loading">
                {{ editedItem.id > 0 ? $t('general.save') : $t('general.create') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-dialog persistent v-model="addExpenseDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.view') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('expenses.viewMessage') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" round flat @click="closeAddExpenseDialog">{{ $t('general.close') }}</v-btn>
            <v-btn color="primary" round depressed :loading="loading" :disabled="loading" @click="sendExpenseView">{{ $t('expenses.view') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="confirmSave" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.edit') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('expenses.sendValidationMultiProject') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="confirmSave = false" color="primary darken-1" round flat>
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn @click="saveReservation" color="primary" round depressed :loading="loading" :disabled="loading">
              {{ $t('general.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- RESERVACIÓN POR COMPROBACIÓN -->
      <section v-if="tabActive === 0">
        <h4 class="my-0 font-weight-bold text__color">{{ $t('expenses.reservations.simple') }}</h4>
        <v-flex>
          <v-layout>
            <v-flex xs5>
              <v-text-field v-model="expenseSearch" :label="$t('general.search')" clearable append-outer-icon="search"></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs5 class="text-right d-flex" v-if="userLogged.roles && userLogged.roles[0].name === 'ADMIN'">
              <v-btn color="primary" round outline @click="dialogRelationsChashier = true"><v-icon left>mdi-cash-register</v-icon> {{ $t('expenses.reservations.generateRelationship') }}</v-btn>
            </v-flex>
            <v-flex xs3 class="text-right d-flex">
              <v-btn color="primary" round outline @click="dialog = true"><v-icon left>attach_money</v-icon> {{ $t('general.add') }}</v-btn>
            </v-flex>
          </v-layout>
          <b-tabs pills active-nav-item-class="primary" v-model="activeTab">
            <b-tab :disabled="disabledTagCheckReservation && statusTagCheckReservation !== 'CREATED'" @click="getByStatus(1, 'CREATED')">
              <template variant="primary" v-slot:title><h5 class="my-0">{{ $t('expenses.status.created') }}</h5></template>
            </b-tab>
            <b-tab :disabled="disabledTagCheckReservation && statusTagCheckReservation !== 'SENT'" @click="getByStatus(2, 'SENT')">
              <template variant="primary" v-slot:title><h5 class="my-0">{{ $t('expenses.status.sented') }}</h5></template>
            </b-tab>
            <b-tab :disabled="disabledTagCheckReservation && statusTagCheckReservation !== 'IN_REVIEW'" @click="getByStatus(3, 'IN_REVIEW')">
              <template variant="primary" v-slot:title><h5 class="my-0">{{ $t('expenses.status.reviewed') }}</h5></template>
            </b-tab>
            <b-tab :disabled="disabledTagCheckReservation && statusTagCheckReservation !== 'PAYABLE'" @click="getByStatus(4, 'PAYABLE')">
              <template variant="primary" v-slot:title><h5 class="my-0">{{ $t('expenses.status.payable') }}</h5></template>
            </b-tab>
            <b-tab :disabled="disabledTagCheckReservation && statusTagCheckReservation !== 'PAYMENT'" @click="getByStatus(5, 'PAYMENT')">
              <template variant="primary" v-slot:title><h5 class="my-0">{{ $t('expenses.status.payment') }}</h5></template>
            </b-tab>
            <b-tab :disabled="disabledTagCheckReservation && statusTagCheckReservation !== 'PAID'" @click="getByStatus(6, 'PAID')">
              <template variant="primary" v-slot:title><h5 class="my-0">{{ $t('expenses.status.paid') }}</h5></template>
            </b-tab>
            <b-tab :disabled="disabledTagCheckReservation && statusTagCheckReservation !== 'REJECTED'" @click="getByStatus(7, 'REJECTED')">
              <template variant="primary" v-slot:title><h5 class="my-0">{{ $t('expenses.status.rejected') }}</h5></template>
            </b-tab>
          </b-tabs>
          <v-data-table
            :search="expenseSearch"
            class="elevation-2"
            :headers="filteredHeaders"
            :items="expenses"
            :loading="loadingItems"
            :rows-per-page-items="[10, 15, 25]"
            :pagination.sync="pagination"
          >
            <template v-slot:headers="props">
              <tr class="bg-heavy-rain">
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    header.sortable ? 'sortable' : '',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  <h2 class="font-weight-black primary--text mb-0">
                    <v-icon small class="primary--text" v-if="header.sortable"
                      >arrow_upward</v-icon
                    >
                    {{ header.text }}
                  </h2>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr class="" @click="props.expanded = !props.expanded">
                <td class="font-weight-black" style="max-width: 30px" v-if="userLogged.roles[0].name === 'EMPLOYEE'">
                  <v-tooltip bottom v-if="props.item">
                    <template v-slot:activator="{ on }">
                      <v-icon v-if="!props.expanded" v-on="on" color="primary">
                        mdi-chevron-down
                      </v-icon>
                      <v-icon v-else v-on="on" color="primary">
                        mdi-chevron-up
                      </v-icon>
                    </template>
                    <span>
                      {{
                        !props.expanded
                          ? $t('general.extend')
                          : $t('general.collapse')
                      }}
                    </span>
                  </v-tooltip>
                </td>
                <td class="text-sm-center">
                  <v-tooltip v-if="props.item.expenses_progress.length > 0 && viewExpenseReject(props.item.expenses_progress)" top>
                    <template v-slot:activator="{ on }">
                      <v-icon style="vertical-align: middle" class="error--text" size="18" v-on="on">mdi-flag</v-icon>
                    </template>
                    <span>{{viewExpenseRejectMessage(props.item.expenses_progress)}}</span>
                  </v-tooltip>
                  {{ props.item.id }}
                </td>
                <td class="text-sm-center">{{ props.item.user && props.item.user.name ? props.item.user.name : '- -' }}</td>
                <td class="text-sm-center">{{ props.item.start_date }} /<br />{{ props.item.end_date }}</td>
                <td class="text-sm-center">{{ props.item.description }}</td>
                <td class="text-sm-center">{{ props.item.project.name }}</td>
                <td class="text-sm-center">{{ props.item.advance | formatCurrency }}</td>
                <td class="text-sm-center" @click.stop>
                  <v-layout v-if="gst_expenses_status_id === 1" row justify-center>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          outline
                          icon
                          color="info"
                          v-on="on"
                          @click="getHistory(props.item)"
                        >
                          <v-icon small>history</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('general.history') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          outline
                          icon
                          color="info"
                          v-on="on"
                          @click="detail(props.item, 1)"
                        >
                          <v-icon small>add</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('expenseItems.add') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <v-btn
                            v-if="props.item.gst_expenses_items.length > 0"
                            :disabled="
                              checkFiscal(props.item.gst_expenses_items)
                            "
                            small
                            outline
                            icon
                            color="info"
                            @click="showWorkflowDialog(props.item)"
                          >
                            <v-icon small>play_arrow</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <span
                        v-if="
                          checkFiscal(props.item.gst_expenses_items) === true
                        "
                        >{{ $t('expenses.xmlPending') }}</span
                      >
                      <span v-else>{{ $t('expenses.sendValidation') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          outline
                          icon
                          color="info"
                          v-on="on"
                          @click="editItem(props.item)"
                        >
                          <v-icon small>edit</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('general.edit') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          outline
                          icon
                          color="error"
                          v-on="on"
                          @click="deleteItem(props.item)"
                        >
                          <v-icon small>delete</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('general.delete') }}</span>
                    </v-tooltip>
                  </v-layout>
                  <v-layout v-if="gst_expenses_status_id === 2" row class="d-inline-flex">
                    <v-flex class="btnStyle">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getAcuse(props.item.id)">
                          <v-icon small>receipt</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('expenses.downloadAccuse') }}</span>
                    </v-tooltip>
                    </v-flex>
                    <v-flex class="btnStyle">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getHistory(props.item)">
                          <v-icon small>history</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('general.history') }}</span>
                    </v-tooltip>
                    </v-flex>
                    <v-flex class="btnStyle">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn :loading="loadingExcelReport === props.item.id" small outline icon class="size-btn" color="green" v-on="on" @click="downloadExcelReport(props.item)">
                          <v-icon small>mdi-file-excel</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('viatics.downloadExcelReport') }}</span>
                    </v-tooltip>
                    </v-flex>
                    <v-flex class="btnStyle" v-if="props.item.travel_expenses_request">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn @click="downloadRequestByComprobacion(props.item)" small outline icon class="size-btn" color="orange" v-on="on">
                            <v-icon small>fas fa-file-invoice-dollar</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('viatics.downloadRequest') }}</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="gst_expenses_status_id === 3" row class="d-inline-flex">
                    <v-flex class="btnStyle">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getAcuse(props.item.id)">
                            <v-icon small>receipt</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('expenses.downloadAccuse') }}</span>
                      </v-tooltip>
                    </v-flex>
                    <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getHistory(props.item)">
                        <v-icon small>history</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('general.history') }}</span>
                    </v-tooltip>
                    <v-flex class="btnStyle">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn :loading="loadingExcelReport === props.item.id" small outline icon class="size-btn" color="green" v-on="on" @click="downloadExcelReport(props.item)">
                            <v-icon small>mdi-file-excel</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('viatics.downloadExcelReport') }}</span>
                      </v-tooltip>
                    </v-flex>
                    <v-tooltip v-if="props.item.travel_expenses_request" bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn :disabled="props.item.created_by && props.item.created_by.id !== userLogged.id" @click="downloadRequestByComprobacion(props.item)" small outline icon color="orange" v-on="on">
                          <v-icon small>fas fa-file-invoice-dollar</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('viatics.downloadRequest') }}</span>
                    </v-tooltip>
                  </v-layout>
                  <v-layout v-if="gst_expenses_status_id === 4" row class="d-inline-flex">
                    <v-flex class="btnStyle">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getAcuse(props.item.id)">
                            <v-icon small>receipt</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('expenses.downloadAccuse') }}</span>
                      </v-tooltip>
                    </v-flex>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getHistory(props.item)">
                          <v-icon small>history</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('general.history') }}</span>
                    </v-tooltip>
                    <v-flex class="btnStyle">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn :loading="loadingExcelReport === props.item.id" small outline icon class="size-btn" color="green" v-on="on" @click="downloadExcelReport(props.item)">
                          <v-icon small>mdi-file-excel</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('viatics.downloadExcelReport') }}</span>
                    </v-tooltip>
                    </v-flex>
                    <v-tooltip v-if="props.item.travel_expenses_request" bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn :disabled="props.item.created_by && props.item.created_by.id !== userLogged.id" @click="downloadRequestByComprobacion(props.item)" small outline icon color="orange" v-on="on">
                          <v-icon small>fas fa-file-invoice-dollar</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('viatics.downloadRequest') }}</span>
                    </v-tooltip>
                  </v-layout>
                  <v-layout v-if="gst_expenses_status_id === 5" row class="d-inline-flex">
                      <v-flex class="btnStyle10Px">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getAcuse(props.item.id)">
                              <v-icon small>receipt</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('expenses.downloadAccuse') }}</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex class="btnStyle10Px">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn small outline icon class="size-btn" color="info" v-on="on" @click="getHistory(props.item)">
                              <v-icon small>history</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('general.history') }}</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex class="btnStyle10Px">
                        <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn :loading="loadingExcelReport === props.item.id" small outline icon class="size-btn" color="green" v-on="on" @click="downloadExcelReport(props.item)">
                            <v-icon small>mdi-file-excel</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('viatics.downloadExcelReport') }}</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex class="btnStyle10Px" v-if="props.item.travel_expenses_request">
                        <v-tooltip bottom >
                          <template v-slot:activator="{ on }">
                            <v-btn :disabled="props.item.created_by && props.item.created_by.id !== userLogged.id" small outline icon color="orange" v-on="on" @click="downloadRequestByComprobacion(props.item)">
                              <v-icon small>fas fa-file-invoice-dollar</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('viatics.downloadRequest') }}</span>
                        </v-tooltip>
                      </v-flex>
                  </v-layout>
                  <v-layout v-if="gst_expenses_status_id === 7" row class="d-inline-flex">
                    <v-flex class="btnStyle10Px">
                      <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <v-btn v-if="props.item.gst_expenses_items.length > 0" 
                            @click="showWorkflowDialog(props.item)"
                            :disabled="checkFiscal(props.item.gst_expenses_items)"
                            small
                            outline
                            icon
                            color="info">
                            <v-icon small>play_arrow</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <span v-if="checkFiscal(props.item.gst_expenses_items) === true">{{ $t('expenses.xmlPending') }}</span>
                      <span v-else>{{ $t('expenses.sendValidation') }}</span>
                    </v-tooltip>
                    </v-flex>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn @click="editItem(props.item)" v-on="on" small outline icon color="info">
                          <v-icon small>edit</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('general.edit') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn @click="deleteItem(props.item)" v-on="on" small outline icon color="error">
                          <v-icon small>delete</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('general.delete') }}</span>
                    </v-tooltip>
                  </v-layout>
                </td>
              </tr>
            </template>
            <template v-slot:expand="props">
              <v-card flat :key="props.item.gst_expenses_items.id">
                <v-layout>
                  <v-layout v-if="!props.item.gst_expenses_items">
                    <v-flex xs12>
                      <p class="text-sm-left ml-4">
                        {{ $t('history.noItem') }}
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-layout v-else>
                    <v-flex xs12>
                      <table width="100%">
                        <thead>
                          <th class="text-sm-center font-weight-black">#</th>
                          <th class="text-sm-center font-weight-black">
                            {{ $t('general.category') }}
                          </th>
                          <th class="text-sm-center font-weight-black">
                            {{ $t('general.description') }}
                          </th>
                          <th class="text-sm-center font-weight-black">
                            {{ $t('general.subtotal') }}
                          </th>
                          <th class="text-sm-center font-weight-black">
                            {{ $t('general.discount') }}
                          </th>
                          <th class="text-sm-center font-weight-black">
                            {{ $t('general.total') }}
                          </th>
                          <th class="text-sm-center font-weight-black">
                            {{ $t('general.exchangeRate') }}
                          </th>
                          <th class="text-sm-center font-weight-black">
                            {{ $t('general.totalMXN') }}
                          </th>
                          <th class="text-sm-center font-weight-black">
                            {{ $t('general.folioRef') }}
                          </th>
                          <th class="text-sm-center font-weight-black">
                            {{ $t('general.date') }}
                          </th>
                          <th class="text-sm-center font-weight-black">
                            {{ $t('general.receiptType') }}
                          </th>
                          <th class="text-sm-center font-weight-black">
                            {{ $t('general.actions') }}
                          </th>
                        </thead>
                        <tr v-for="item of props.item.gst_expenses_items" :key="item.id" :class="{'custom-row-color': item.gst_receipt_types_id === 4}">
                          <td class="text-sm-center">{{ item.id }}</td>
                          <td class="text-sm-center">
                            {{ item.gst_categories_id }}
                          </td>
                          <td class="text-sm-center">
                            {{ item.description }}
                          </td>
                          <td class="text-sm-center">
                            {{ item.subtotal | formatCurrency }}
                          </td>
                          <td class="text-sm-center">
                            {{ item.discount | formatCurrency }}
                          </td>
                          <td class="text-sm-center">{{ item.total }}</td>
                          <td class="text-sm-center">{{ item.exchange }}</td>
                          <td class="text-sm-center">
                            {{ item.total_mxn | formatCurrency }}
                          </td>
                          <td class="text-sm-center">{{ item.folio }}</td>
                          <td class="text-sm-center">{{ item.date }}</td>
                          <td class="text-sm-center">
                            {{ item.gst_receipt_types_id }}
                          </td>
                          <td class="text-sm-center">
                            <v-tooltip
                              top
                              v-if="item.gst_receipt_types_id === 2"
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  v-on="on"
                                  small
                                  outline
                                  round
                                  color="primary"
                                  icon
                                  @click="viewItems(item)"
                                >
                                  <v-icon small>remove_red_eye</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('general.seeMore') }}</span>
                            </v-tooltip>
                            <v-tooltip top v-else>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  v-on="on"
                                  small
                                  outline
                                  round
                                  color="primary"
                                  icon
                                  @click="viewItemsF(item)"
                                >
                                  <v-icon small>remove_red_eye</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('general.seeMore') }}</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </table>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-card>
            </template>
          </v-data-table>
        </v-flex>
      </section>
      <!-- RESERVACIÓN POR SOLICITUD -->
      <section v-if="tabActive === 1">
        <h4 class="my-0 font-weight-bold text__color">{{ $t('expenses.reservations.request') }} </h4>
        <v-flex>
          <v-layout>
            <v-flex xs5>
              <v-text-field v-model="requestSearch" :label="$t('general.search')" clearable append-outer-icon="search"></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs5 class="text-right d-flex" v-if="userLogged.roles && userLogged.roles[0].name === 'ADMIN'">
              <v-btn color="primary" round outline @click="dialogRelationsChashier = true">
                <v-icon left> mdi-cash-register</v-icon>{{ $t('expenses.reservations.generateRelationship') }}
              </v-btn>
            </v-flex>
            <v-flex xs3 class="text-right d-flex">
              <v-btn :disabled="requestEditValidate === false" color="primary" round outline @click="openDialogRequest()">
                <v-icon left>add</v-icon>{{ $t('viatics.new') }}
              </v-btn>
            </v-flex>
          </v-layout>
          <b-tabs pills active-nav-item-class="primary" v-model="activeTabReserva">
            <b-tab :disabled="disabledTag && statusTag !== 'CREATED'" @click="getRequestTags('CREATED')">
              <template variant="primary" v-slot:title><h5 class="my-0">{{ $t('expenses.status.created') }}</h5></template>
            </b-tab>
            <b-tab :disabled="disabledTag && statusTag !== 'IN_REVIEW'" @click="getRequestTags('IN_REVIEW')">
              <template variant="primary" v-slot:title><h5 class="my-0">{{ $t('expenses.status.reviewed') }}</h5></template>
            </b-tab>
            <b-tab :disabled="disabledTag && statusTag !== 'APPROVED'" @click="getRequestTags('APPROVED')">
              <template variant="primary" v-slot:title><h5 class="my-0">{{ $t('expenses.status.approved') }}</h5></template>
            </b-tab>
            <b-tab :disabled="disabledTag && statusTag !== 'REJECTED'" @click="getRequestTags('REJECTED')">
              <template variant="primary" v-slot:title><h5 class="my-0">{{ $t('expenses.status.rejected') }}</h5></template>
            </b-tab>
            <b-tab :disabled="disabledTag && statusTag !== undefined" @click="getRequestTags(undefined)">
              <template variant="primary" v-slot:title><h5 class="my-0">{{ $t('general.alls') }}</h5></template>
            </b-tab>
          </b-tabs>
          <v-data-table
            :headers="filteredHeadersRequest"
            :search="requestSearch"
            :items="filterViatics"
            :loading="loadingItemsReservations"
            :rows-per-page-items="[10, 15, 25]"
            :pagination.sync="pagination"
            class="elevation-2">
            <template v-slot:headers="props">
              <tr class="bg-heavy-rain">
                <th v-for="header in props.headers" :key="header.text"
                  :class="[ 'column', header.sortable ? 'sortable' : '', pagination.descending ? 'asc' : 'desc', header.value === pagination.sortBy ? 'active' : '']"
                  @click="changeSort(header.value)">
                  <h2 class="font-weight-black primary--text mb-0">
                    <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                    {{ header.text }}
                  </h2>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr class="">
                <td class="text-sm-center">{{ props.item.folio }}</td>
                <td class="text-sm-center">{{ props.item.user_assigned && props.item.user_assigned.name ? props.item.user_assigned.name : props.item.user.name }}</td>
                <td class="text-sm-center">{{ props.item.creation_date }}</td>
                <td class="text-sm-center">{{ props.item.project.name }}</td>
                <td class="text-sm-center">{{ advanceCalculate(props.item, props.item.amount_advance) | formatCurrency }}</td>
                <td class="text-sm-center">{{ getStatusSpanish(props.item.status) }}</td>
                <td class="text-sm-center" style="width: 180px">
                  <v-layout style="padding: 12px 0px 1px; ">
                    <v-flex v-if="props.item.status === 'CREATED' || props.item.status === 'REJECTED'" class="btnStyle10Px">
                      <v-tooltip  class="ma-0 pa-0" bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn @click="editItemRequest(props.item)" :disabled="actionsLoading === true" class="ma-0 pa-0" small outline icon color="info" v-on="on">
                            <v-icon small>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('general.edit') }}</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex v-if="props.item.status === 'CREATED'" class="btnStyle10Px">
                      <v-tooltip class="ma-0 pa-0" bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn @click="sendRequest(props.item.id)" class="ma-0 pa-0" small outline icon color="info" v-on="on">
                            <v-icon small>mdi-send</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('viatics.send') }}</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex v-if="props.item.status === 'CREATED' || props.item.status === 'REJECTED'" class="btnStyle10Px">
                      <v-tooltip class="ma-0 pa-0" bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn @click="confirmDelete(props.item)" class="ma-0 pa-0" small outline icon color="#F7665E" v-on="on">
                            <v-icon small>mdi-trash-can</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('viatics.deleteRequest') }}</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex v-if="props.item.status === 'APPROVED' || props.item.status === 'SENT' || props.item.status === 'IN_REVIEW'" class="btnStyle10Px">
                      <v-tooltip class="ma-0 pa-0" bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn @click="editItemRequest(props.item)" class="ma-0 pa-0" small outline icon color="info" v-on="on">
                            <v-icon small>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('general.seeMore') }}</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex v-if="props.item.status === 'APPROVED'" class="btnStyle10Px">
                      <v-tooltip class="ma-0 pa-0" bottom >
                        <template v-slot:activator="{ on }">
                          <v-btn @click="createExpense(props.item)" :disabled="props.item.gst_expense !== null" class="ma-0 pa-0" small outline icon color="primary" v-on="on">
                            <v-icon small>fas fa-file-invoice-dollar</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('expenses.create') }}</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex v-if="props.item.status === 'APPROVED' && props.item.gst_expense !== null" class="btnStyle10Px">
                      <v-tooltip class="ma-0 pa-0" bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn @click="detail(props.item, 2)" class="ma-0 pa-0" small outline icon color="info" v-on="on">
                            <v-icon small>add</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('expenseItems.add') }}</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="props.item.gst_expense !== null">
                    <v-flex>
                      <b>{{ $t('expenses.name') }}: </b> {{props.item.gst_expense.id}}
                    </v-flex>
                  </v-layout>
                </td>
              </tr>
            </template>
            <template v-slot:no-data>
              <div class="text-center">
                <div v-if="disabledTag">
                  {{ $t('dataTable.loadingRecords') }}
                </div>
                <div v-else>
                  {{ $t('dataTable.noResult') }}
                </div>
              </div>
            </template>
          </v-data-table>
        </v-flex>
      </section>

      <v-dialog persistent v-model="dialogViewFile" scrollable max-width="900px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{$t('expenses.file') + ': ' + watchItem.id}}</h2>
          </v-toolbar>
          <v-card-text class="text-center">
            <iframe v-if="watchItem.files_type_id === 3 && dataURLFile" :src="dataURL" frameborder="0" width="100%" height="400px" />
            <zoom-on-hover v-if="dataURLFile && watchItem.files_type_id !== 3" :img-normal="dataURLFile"/>
            <v-btn color="primary" @click="downloadFile()" :loading="loadBtn" :disabled="loadBtn" v-if="(watchItem.files_type_id === 9 || watchItem.files_type_id === 12) && !loadFile">volver a descargar</v-btn>
            <v-progress-circular v-if="!dataURLFile && loadFile" color="primary" size="50" indeterminate />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error darken-1" round flat @click="closeViewFile"> {{ $t('general.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="removeDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">
              {{ $t('expenses.delete') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
            <p class="font-weight-black">
              <span class="error--text">{{ $t('expenses.description') }}: </span
              >{{ editedItem.description }}
            </p>
            <p class="font-weight-black">
              <span class="error--text">{{ $t('general.employee') }}: </span
              >{{ editedItem.user !== undefined ? editedItem.user.name : '' }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="removeItem"
            >
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="workflowDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.sendValidation') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('expenses.sendValidationMessage') }}</p>
            <p class="font-weight-black">
              <span class="primary--text"
                >{{ $t('expenses.description') }}: </span
              >{{ editedItem.description }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              round
              flat
              @click="closeWorkflowDialog"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              round
              depressed
              :loading="loading"
              :disabled="loading"
              @click="doStartWorkflow"
            >
              {{ $t('expenses.start') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="workflowDialogValidate" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.blueVoucher.errorWorkFlow') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('expenses.blueVoucher.errorFile') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              round
              flat
              @click="workflowDialogValidate=false"
            >
              {{ $t('general.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="histDialog" max-width="900px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.tracking') }}
            </h2>
          </v-toolbar>
          <v-card-text v-if="histLoading">
            <v-layout>
              <v-flex class="text-center">
                <v-progress-circular color="primary" indeterminate size="50" />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-text v-if="!histLoading">
            <v-layout wrap>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black"
                    >{{ $t('workflowValidation.expenseNo') }}: </span
                  >{{ histItem.id }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black"
                    >{{ $t('general.workflow') }}: </span
                  >{{ workflowName }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black"
                    >{{ $t('general.description') }}: </span
                  >{{ histItem.description }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <h3><span class="primary--text font-weight-black">{{$t('general.project')}}: </span>{{histItem.project.name}}</h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black"
                    >{{ $t('general.startDate') }}: </span
                  >{{ histItem.start_date }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <h3>
                  <span class="primary--text font-weight-black"
                    >{{ $t('general.endDate') }}: </span
                  >{{ histItem.end_date }}
                </h3>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-divider />
                <h3 class="primary--text font-weight-black">
                  {{ $t('expenses.progress') }}:
                </h3>
                <v-card flat color="grey lighten-3">
                  <v-layout>
                    <v-flex
                      class="text-center py-3"
                      :class="
                        histSteps.sented.length > 0
                          ? 'hist-steps white--text'
                          : 'grey--text'
                      "
                      xs4
                    >
                      <v-avatar
                        class="mr-2"
                        size="20"
                        :color="histSteps.sented.length > 0 ? 'white' : 'grey'"
                      >
                        <v-icon
                          v-if="histSteps.sented.length > 0"
                          class="font-weight-black"
                          small
                          >check</v-icon
                        >
                        <span v-else class="white--text font-weight-black"
                          >1</span
                        >
                      </v-avatar>
                      <span class="font-weight-black my-3">{{
                        $t('expenses.exs.sented')
                      }}</span>
                    </v-flex>
                    <v-divider vertical />

                    <v-flex
                      class="text-center py-3"
                      :class="
                        histSteps.reviewed.length > 0
                          ? 'hist-steps white--text'
                          : 'grey--text'
                      "
                      xs4
                    >
                      <v-avatar
                        class="mr-2"
                        size="20"
                        :color="
                          histSteps.reviewed.length > 0 ? 'white' : 'grey'
                        "
                      >
                        <v-icon
                          v-if="histSteps.reviewed.length > 0"
                          class="font-weight-black"
                          small
                          >check</v-icon
                        >
                        <span v-else class="white--text font-weight-black"
                          >2</span
                        >
                      </v-avatar>
                      <span class="font-weight-black my-3">{{
                        $t('expenses.exs.reviewed')
                      }}</span>
                    </v-flex>

                    <v-divider vertical />

                    <v-flex
                      class="text-center py-3"
                      :class="
                        histSteps.payable.length
                          ? 'hist-steps white--text'
                          : 'grey--text'
                      "
                      xs4
                    >
                      <v-avatar
                        class="mr-2"
                        size="20"
                        :color="histSteps.payable.length ? 'white' : 'grey'"
                      >
                        <v-icon
                          v-if="histSteps.payable.length"
                          class="font-weight-black"
                          small
                          >check</v-icon
                        >
                        <span v-else class="white--text font-weight-black"
                          >3</span
                        >
                      </v-avatar>
                      <span class="font-weight-black my-3">{{
                        $t('expenses.exs.approved')
                      }}</span>
                    </v-flex>
                    <v-divider vertical />

                    <v-flex
                      class="text-center py-3"
                      :class="
                        histSteps.paid.length
                          ? 'hist-steps white--text'
                          : 'grey--text'
                      "
                      xs4
                    >
                      <v-avatar
                        class="mr-2"
                        size="20"
                        :color="histSteps.paid.length ? 'white' : 'grey'"
                      >
                        <v-icon
                          v-if="histSteps.paid.length"
                          class="font-weight-black"
                          small
                          >check</v-icon
                        >
                        <span v-else class="white--text font-weight-black"
                          >4</span
                        >
                      </v-avatar>
                      <span class="font-weight-black my-3">{{
                        $t('expenses.exs.paid')
                      }}</span>
                    </v-flex>
                  </v-layout>
                  <v-divider class="my-0 primary" />
                  <v-layout>
                    <v-flex v-if="histSteps.sented.length > 0" class="text-center pa-3" xs4>
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.sented') }}:
                      </h3>
                      <li class="text-sm-left">
                        {{ histSteps.sented[0].user.name + ' - ' + histSteps.sented[0].created_at }}
                      </li>
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.inRepresentationOf') }}:
                      </h3>
                      <li class="text-sm-left">
                        {{ representExpense.name }}
                      </li>
                    </v-flex>
                    <v-flex v-else-if="creatorExpense && representExpense" class="text-center pa-3" xs4>
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.sented') }}:
                      </h3>
                      <li>
                        {{ creatorExpense.name }}
                      </li>
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.inRepresentationOf') }}:
                      </h3>
                      <li>{{representExpense.name }}</li>
                    </v-flex>
                    <v-flex v-else class="text-center pa-3" xs4>
                      <h3 class="grey--text font-weight-black py-2">
                        {{ $t('expenses.history.pending') }}
                      </h3>
                    </v-flex>
                    <v-divider class="primary" vertical />
                    <v-flex>
                    </v-flex>
                    <v-flex v-if="histSteps.reviewed.length > 0" class="text-center pa-3" xs4><!-- COLOCA LOS QUE YA REVISARON -->
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.reviewed') }}:
                      </h3>
                      <li v-for="step of histSteps.reviewed" :key="step.id" class="text-sm-left">
                        {{ step.user.name + ' - ' + step.created_at }}
                      </li>
                      <v-flex v-if="validatorsExpenses !== null && isApproved === false">
                        <h3 v-if="pendingValidatorsC.length > 0" class="grey--text font-weight-black py-2">
                          {{ $t('expenses.history.pending') }}
                        </h3>
                        <ul v-for="validator of pendingValidatorsC" :key="validator.validator.user_id" class="text-sm-left">
                          <h6 class="text-center font-weight-black">
                            {{ $t('validator.name') }} {{ validator.validatorId }}
                          </h6>
                          {{ validator.validator.user.name }}
                          <h6 v-if="validator.substitutes !== null" class="text-center grey--text pt-1">
                            {{ $t('general.substitutes') }}
                          </h6>
                          <li v-if="validator.substitutes !== null" class="text-sm-left grey--text">
                            {{ validator.substitutes.user.name }}
                          </li>
                        </ul>
                        <v-spacer></v-spacer>
                      </v-flex>
                    </v-flex>
                    <v-flex v-else class="text-center pa-3" xs4>
                      <h3 v-if="validators.length > 0" class="grey--text font-weight-black py-2">
                        {{ $t('expenses.history.pending') }}
                      </h3>
                      <ul v-for="validator of validators" :key="validator.id">
                        <h6 class="text-center font-weight-black">
                          {{ $t('validator.name') }} {{ validator.validatorId }}
                        </h6>
                        <li class="text-sm-left grey--text">
                          {{ validator.validator.user.name }}
                        </li>
                        <h6 v-if="validator.substitutes !== null" class="text-center grey--text pt-1">
                          {{ $t('general.substitutes') }}
                        </h6>
                        <li v-if="validator.substitutes !== null" class="text-sm-left grey--text">
                          {{ validator.substitutes.user.name }}
                        </li>
                        <v-spacer></v-spacer>
                      </ul>
                    </v-flex>
                    <v-divider class="primary" vertical />
                    <v-flex
                      v-if="histSteps.payable.length > 0"
                      class="text-center pa-3"
                      xs4
                    >
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.payable') }}:
                      </h3>
                      <li
                        class="text-sm-left"
                        v-for="step of histSteps.payable"
                        :key="step.id"
                      >
                        {{ step.user.name + ' - ' + step.created_at }}
                      </li>
                    </v-flex>
                    <v-flex v-else class="text-center pa-3" xs4>
                      <h3 class="grey--text font-weight-black py-2">
                        {{ $t('expenses.history.pending') }}
                      </h3>
                      <ul v-for="approver of approvers" :key="approver.id">
                        <li class="text-sm-left grey--text">
                          {{ approver.users[0].name }}
                        </li>
                      </ul>
                    </v-flex>
                    <v-divider class="primary" vertical />
                    <v-flex
                      v-if="histSteps.paid.length > 0"
                      class="text-center pa-3"
                      xs4
                    >
                      <h3 class="primary--text font-weight-black">
                        {{ $t('expenses.history.paid') }}:
                      </h3>
                      <li
                        class="text-sm-left"
                        v-for="step of histSteps.paid"
                        :key="step.id"
                      >
                        {{ step.user.name + ' - ' + step.created_at }}
                      </li>
                    </v-flex>
                    <v-flex v-else class="text-center pa-3" xs4>
                      <h3 class="grey--text font-weight-black py-2">
                        {{ $t('expenses.history.pending') }}
                      </h3>
                      <ul v-for="approver of approvers" :key="approver.id">
                        <li class="text-sm-left grey--text">
                          <!-- {{ approver.users[0].name }} -->
                             <!-- ÚNICO CASO ARLETTE -->
                          {{ (userLogged && userLogged.company && userLogged.company[0] && (userLogged.company[0].id === 49 || userLogged.company[0].id === 50)) ? 'BARAJAS PEREZ ARLETTE DANIELA' : approver.users[0].name }}
                        </li>
                      </ul>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" round flat @click="close">
              {{ $t('general.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogNF" scrollable max-width="800px" persistent>
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('workflowValidation.item') }}{{ editedItemNF.id }}
              <span>
                (
                {{
                  editedItemNF.receipt_type
                    ? editedItemNF.receipt_type.name
                    : ''
                }}
                )</span
              >
            </h2>
          </v-toolbar>
          <v-card-text>
            <v-form lazy-validation ref="form" v-model="valid">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex layout row wrap v-bind:class="{ xs6: dataURL }">
                    <v-flex xs12 md6>
                      <v-text-field
                        :label="$t('general.date')"
                        disabled
                        outline
                        v-model="editedItemNF.date"
                      >
                      </v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 md6>
                    <v-text-field
                      :label="$t('general.category')"
                      disabled
                      outline
                      v-model="editedItemNF.gst_categories.name">
                    </v-text-field>
                  </v-flex> -->
                    <v-flex xs12 md6>
                      <v-text-field
                        :label="$t('general.country')"
                        disabled
                        outline
                        v-model="editedItemNF.country.descripcion"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        :label="$t('general.description')"
                        disabled
                        outline
                        v-model="editedItemNF.description"
                      >
                      </v-textarea>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        :label="$t('general.currency')"
                        disabled
                        outline
                        v-model="editedItemNF.currency.descripcion"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        :label="$t('general.exchangeRate')"
                        disabled
                        outline
                        v-model="editedItemNF.exchange"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        :label="$t('general.subtotal')"
                        disabled
                        outline
                        v-model="editedItemNF.subtotal"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        :label="$t('general.total')"
                        disabled
                        outline
                        v-model="editedItemNF.total"
                      >
                      </v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 md6>
                    <v-text-field
                      :label="$t('general.formaPago')"
                      disabled
                      outline
                      v-model="editedItemNF.sat_forma_pago.descripcion">
                    </v-text-field>
                  </v-flex> -->
                    <v-flex xs12 md6>
                      <v-text-field
                        :label="$t('general.folioRef')"
                        disabled
                        outline
                        v-model="editedItemNF.folio"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        :label="$t('general.comment')"
                        disabled
                        outline
                        v-model="editedItemNF.comment"
                      >
                      </v-textarea>
                    </v-flex>
                  </v-flex>
                  <v-flex xs6 layout v-if="dataURL">
                    <v-flex xs12>
                      <a v-if="!isPDF(dataURL)" @click="openPDF()">
                        <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                      </a>
                      <v-btn
                        block
                        v-if="isPDF(dataURL)"
                        @click="openPDF()"
                        color="primary"
                        depressed
                      >
                        <v-icon left>insert_drive_file</v-icon>
                        {{ $t('expenseItems.watchFile') }}
                      </v-btn>
                      <iframe
                        v-if="isPDF(dataURL)"
                        :src="dataURL"
                        frameborder="0"
                        width="100%"
                        height="400px"
                      ></iframe>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary darken-1"
              flat
              round
              class="white--text"
              depressed
              @click="close"
            >
              {{ $t('general.close') }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-flex class="text-xs-right">
        <v-dialog v-model="dialogF" scrollable max-width="900px" persistent>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">
                {{ $t('workflowValidation.item') }}{{ editedItemF.id }}
                <span>
                  (
                  {{
                    editedItemF.receipt_type
                      ? editedItemF.receipt_type.name
                      : ''
                  }}
                  )</span
                >
              </h2>
              <v-spacer />
              <v-btn round flat color="primary" @click="sendToPrint()"
                ><v-icon left>print</v-icon> {{ $t('general.print') }}</v-btn
              >
            </v-toolbar>
            <v-card-text>
              <iframe
                name="cfdi"
                :srcdoc="cfdiHtml"
                style="width: 845px; height: 1200px; border: 0"
              >
              </iframe>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 md6>
                    <v-text-field
                      :label="$t('general.category')"
                      disabled
                      outline
                      v-model="editedItemF.gst_categories.name"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      :label="$t('general.comment')"
                      disabled
                      outline
                      v-model="editedItemF.comment"
                    >
                    </v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary darken-1"
                flat
                round
                class="white--text"
                depressed
                @click="close"
              >
                {{ $t('general.close') }}
              </v-btn>
              <v-spacer />
              <div v-if="editedItemF.receipt_type">
                <v-btn
                  color="success darken-1"
                  round
                  flat
                  v-if="editedItemF.receipt_type.id == 1"
                  :loading="loadingXML"
                  @click="downloadXML('itemF')"
                >
                  {{ $t('general.downloadXML') }}
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-dialog
        v-model="dialogRequest"
        max-width="1370px"
        scrollable
        persistent
      >
        <v-card>
          <v-toolbar class="primary--text" flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ formTitleRequest }}
            </h2>
          </v-toolbar>
          <v-card-text>
            <v-form
                lazy-validation
                ref="formDialogRequest"
                v-model="validApproved"
                class="mx-2 px-2"
              >
                <v-layout>
                  <v-flex md12>
                    <h3 class="font-weight-black primary--text mb-0">
                      {{ $t('viatics.generalData') }}
                    </h3>
                    <v-layout>
                      <v-flex v-if="editedIndex !== -1">
                        <div class="subtitle-1 mt-2">
                          {{ $t('viatics.folio') }} :
                        </div>
                        <v-layout v-if="editedIndex !== -1">
                          <v-flex class="pr-5">
                            <v-text-field
                              clearable
                              class="mt-2"
                              required
                              :rules="rules.required"
                              :error-messages="errors.folio"
                              v-model="editedItemRequest.folio"
                              :disabled="true"
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex>
                        <div class="subtitle-1 mt-2">
                          {{ $t('viatics.requestDate') }} :
                        </div>
                        <v-layout>
                          <v-flex class="pr-5">
                            <v-text-field
                              clearable
                              class="mt-2"
                              required
                              :rules="rules.required"
                              :error-messages="errors.creation_date"
                              v-model="editedItemRequest.creation_date"
                              :disabled="true"
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex>
                        <div class="subtitle-1 mt-2">
                          {{ $t('viatics.user') }} :
                        </div>
                        <v-text-field
                          clearable
                          class="mt-2 pr-5"
                          required
                          :rules="rules.required"
                          :error-messages="errors.name"
                          v-model="editedItemRequest.user.name"
                          :disabled="true"
                        />
                      </v-flex>

                      <v-flex>
                        <div class="subtitle-1 mt-2">
                          {{ $t('viatics.assignedTo') }} :
                        </div>
                        <v-layout row wrap>
                          <v-flex class="pr-0">
                            <v-autocomplete
                              class="mt-2 pr-0"
                              v-model="editedItemRequest.assigned_user_id"
                              item-text="name"
                              item-value="id"
                              persistent-hint
                              :rules="rules.required"
                              :items="usersFilter"
                              :disabled="editUserAssined && editedIndex !== -1"
                            />
                          </v-flex>
                          <v-flex
                            md1
                            v-if="
                              editedIndex !== -1 &&
                              statusRequestEdit === 'CREATED'
                            "
                          >
                            <v-btn
                              icon
                              :color="editUserAssined ? 'primary' : 'grey'"
                              @click="editUserAssined = !editUserAssined"
                            >
                              <v-icon>{{
                                editUserAssined
                                  ? 'mdi-pencil'
                                  : 'mdi-pencil-off'
                              }}</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex class="mr-5" md5>
                        <div class="subtitle-1 mt-2">
                          {{ $t('viatics.travelPeriod') }} :
                        </div>
                        <v-layout>
                          <v-flex class="pr-5">
                            <v-menu
                              v-model="menuApproved"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  class="pt-2 mt-0"
                                  required
                                  :rules="rules.required"
                                  :error-messages="errors.startDate"
                                  v-model="editedItemRequest.start_date"
                                  :label="$t('viatics.from')"
                                  prepend-icon="event"
                                  readonly
                                  :disabled="editDates && editedIndex !== -1"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                :max="editedItemRequest.end_date"
                                color="primary"
                                v-model="editedItemRequest.start_date"
                                @input="menu = false"
                                :locale="$t('history.local')"
                              >
                              </v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex class="pr-5">
                            <v-menu
                              v-model="menu2Approved"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  class="pt-2 mt-0"
                                  required
                                  :rules="rules.required"
                                  v-model="editedItemRequest.end_date"
                                  :error-messages="errors.endDate"
                                  :label="$t('viatics.to')"
                                  prepend-icon="event"
                                  readonly
                                  v-on="on"
                                  :disabled="editDates && editedIndex !== -1"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                color="primary"
                                v-model="editedItemRequest.end_date"
                                @input="menu2Approved = false"
                                :min="editedItemRequest.start_date"
                                :locale="$t('history.local')"
                              >
                              </v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex
                            md1
                            v-if="
                              editedIndex !== -1 && statusRequestEdit === 'CREATED'
                            "
                            >
                            <v-btn
                              icon
                              :color="editDates ? 'primary' : 'grey'"
                              @click="editDates = !editDates"
                            >
                              <v-icon>{{
                                editDates ? 'mdi-pencil' : 'mdi-pencil-off'
                              }}</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="mr-4" md4>
                        <div class="subtitle-1 mt-2">
                          {{ $t('general.project') }} :
                        </div>
                        <v-layout>
                          <v-flex class="pr-0">
                            <v-autocomplete
                              class="pt-2 mt-1"
                              v-model="editedItemRequest.project_id"
                              item-text="name"
                              item-value="id"
                              persistent-hint
                              :rules="rules.required"
                              :items="projects"
                              :disabled="editProject && editedIndex !== -1"
                            />
                          </v-flex>
                          <v-flex
                            md1
                            v-if="
                              editedIndex !== -1 &&
                              statusRequestEdit === 'CREATED'
                            "
                          >
                            <v-btn
                              icon
                              :color="editProject ? 'primary' : 'grey'"
                              @click="editProject = !editProject"
                            >
                              <v-icon>{{
                                editProject ? 'mdi-pencil' : 'mdi-pencil-off'
                              }}</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="mr-4" md4>
                          <div class="subtitle-1 mt-2">
                            {{ $t('general.orderNumber') }} :
                          </div>
                          <v-layout>
                          <v-flex class="pr-0">
                            <v-text-field
                              class="pt-2 mt-0"
                              v-model="editedItemRequest.order_number"
                              :disabled="editOrderNumber && editedIndex !== -1"
                            ></v-text-field>
                          </v-flex>
                          <v-flex
                            md1
                            v-if="
                              editedIndex !== -1 && statusRequestEdit === 'CREATED'
                            "
                            >
                            <v-btn
                              icon
                              :color="editOrderNumber ? 'primary' : 'grey'"
                              @click="editOrderNumber = !editOrderNumber"
                            >
                              <v-icon>{{
                                editOrderNumber ? 'mdi-pencil' : 'mdi-pencil-off'
                              }}</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <div class="subtitle-1 pb-0 mb-0">
                      {{ $t('general.description') }} :
                    </div>
                    <v-layout>
                      <v-flex md12>
                        <v-textarea
                          class="pt-0 mt-0"
                          v-model="editedItemRequest.description"
                          :error-messages="errors.description"
                          :disabled="editDescription && editedIndex !== -1"
                          auto-grow
                          rows="1"
                        ></v-textarea>
                      </v-flex>
                      <v-flex
                        md1
                        v-if="
                          editedIndex !== -1 && statusRequestEdit === 'CREATED'
                        "
                      >
                        <v-btn
                          icon
                          :color="editDescription ? 'primary' : 'grey'"
                          @click="editDescription = !editDescription"
                        >
                          <v-icon>{{
                            editDescription ? 'mdi-pencil' : 'mdi-pencil-off'
                          }}</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout class="pr-5">
                      <v-flex class="pa-0" md11>
                        <v-checkbox
                          class="mb-0 pb-0"
                          v-model="editedItemRequest.is_travel"
                          :error-messages="errors.is_travel"
                          :disabled="editIsTravel && editedIndex !== -1"
                          :label="$t('viatics.travelQuestion')"
                        >
                        </v-checkbox>
                      </v-flex>
                      <v-flex
                        md1
                        v-if="
                          editedIndex !== -1 &&
                          statusRequestEdit === 'CREATED'
                        "
                      >
                        <v-btn
                          icon
                          :color="editIsTravel ? 'primary' : 'grey'"
                          @click="editIsTravel = !editIsTravel"
                        >
                          <v-icon>{{
                            editIsTravel ? 'mdi-pencil' : 'mdi-pencil-off'
                          }}</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex md4>
                        <div
                          v-if="editedItemRequest.is_travel"
                          class="subtitle-1 mt-2"
                        >
                          {{ $t('viatics.travelType') }}
                          <span
                            md1
                            v-if="
                              editedIndex !== -1 &&
                              statusRequestEdit === 'CREATED'
                            "
                          >
                            <v-btn
                              icon
                              small
                              v-if="editedItemRequest.is_travel"
                              :color="editTravelType ? 'primary' : 'grey'"
                              @click="editTravelType = !editTravelType"
                            >
                              <v-icon small>{{
                                editTravelType ? 'mdi-pencil' : 'mdi-pencil-off'
                              }}</v-icon>
                            </v-btn>
                          </span>

                          :
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div
                          v-if="editedItemRequest.is_travel"
                          class="subtitle-1 mt-2"
                        >
                          {{ $t('viatics.origin') }}
                          <span
                            md1
                            v-if="
                              editedIndex !== -1 &&
                              statusRequestEdit === 'CREATED' &&
                              editedItemRequest.is_travel
                            "
                          >
                            <v-btn
                              icon
                              small
                              :color="editOrigin ? 'primary' : 'grey'"
                              @click="editOrigin = !editOrigin"
                            >
                              <v-icon small>{{
                                editOrigin ? 'mdi-pencil' : 'mdi-pencil-off'
                              }}</v-icon>
                            </v-btn>
                          </span>
                          :
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div
                          v-if="editedItemRequest.is_travel"
                          class="subtitle-1 mt-2"
                        >
                          {{ $t('viatics.destination') }}
                          <span
                            md1
                            v-if="
                              editedIndex !== -1 &&
                              statusRequestEdit === 'CREATED'
                            "
                          >
                            <v-btn
                              icon
                              small
                              :color="editDestination ? 'primary' : 'grey'"
                              @click="editDestination = !editDestination"
                            >
                              <v-icon small>{{
                                editDestination
                                  ? 'mdi-pencil'
                                  : 'mdi-pencil-off'
                              }}</v-icon>
                            </v-btn>
                          </span>
                          :
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout v-if="editedItemRequest.is_travel">
                      <v-flex md4>
                        <v-autocomplete
                          class="pr-5 mt-0 pt-0 ajuste"
                          v-model="editedItemRequest.travel_type.id"
                          item-text="name"
                          item-value="id"
                          :items="travelTypes"
                          :disabled="editTravelType && editedIndex !== -1"
                        />
                      </v-flex>
                      <v-flex md4>
                        <v-text-field
                          class="pr-5 mt-0 pt-0"
                          clearable
                          :error-messages="errors.origin"
                          v-model="editedItemRequest.origin"
                          :disabled="editOrigin && editedIndex !== -1"
                        />
                      </v-flex>
                      <v-flex md4>
                        <v-text-field
                          clearable
                          class="mt-0 pt-0"
                          :error-messages="errors.destination"
                          v-model="editedItemRequest.destination"
                          :disabled="editDestination && editedIndex !== -1"
                        />
                      </v-flex>
                    </v-layout>
                    <!-- datos del vehiculo -->
                    <v-layout>
                      <v-flex class="pa-0" md11>
                        <v-checkbox
                          class="mb-0 pb-0"
                          v-model="editedItemRequest.is_vehicle"
                          :disabled="editIsVehicle && editedIndex !== -1"
                          :label="$t('viatics.vehicleQuestion')"
                        >
                        </v-checkbox>
                      </v-flex>
                      <v-flex
                        md1
                        v-if="
                          editedIndex !== -1 &&
                          statusRequestEdit === 'CREATED'
                        "
                      >
                        <v-btn
                          icon
                          :color="editIsVehicle ? 'primary' : 'grey'"
                          @click="editIsVehicle = !editIsVehicle"
                        >
                          <v-icon>{{
                            editIsVehicle ? 'mdi-pencil' : 'mdi-pencil-off'
                          }}</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      v-if="
                        editedItemRequest.is_vehicle
                      "
                    >
                      <v-flex md3>
                        <v-autocomplete
                          class="pr-5 mt-0 pt-0 ajuste"
                          v-model="
                            editedItemRequest.fuelRequests[0].gst_vehicle_id
                          "
                          :label="$t('general.vehicle')"
                          item-text="name"
                          item-value="id"
                          :items="vehicles"
                          :disabled="
                            editIsVehicle &&
                            editedIndex !== -1 &&
                            editedItemRequest.status !== 'APPROVED'
                          "
                        />
                      </v-flex>
                      <v-flex md3>
                        <v-text-field
                          class="pr-5 mt-0 pt-1"
                          disabled
                          :label="$t('general.licensePlate')"
                          :error-messages="errors.origin"
                          v-model="getLicencePlate"
                        />
                      </v-flex>
                      <v-flex md3>
                        <v-text-field
                          class="pr-5 mt-0 pt-0 ajuste"
                          v-model="
                            editedItemRequest.fuelRequests[0].initial_milleage
                          "
                          :label="$t('general.initialMileage')"
                          type="number"
                          step="1"
                          :disabled="
                            editIsVehicle &&
                            editedIndex !== -1 &&
                            editedItemRequest.status !== 'APPROVED'
                          "
                        />
                      </v-flex>
                      <v-flex md3>
                        <v-text-field
                          class="pr-5 mt-0 pt-0 ajuste"
                          v-model="
                            editedItemRequest.fuelRequests[0].final_milleage
                          "
                          label="Kilometraje final"
                          type="number"
                          step="1"
                          :disabled="
                            editIsVehicle &&
                            editedIndex !== -1 &&
                            editedItemRequest.status !== 'APPROVED'
                          "
                        />
                      </v-flex>
                      <v-flex md3>
                        <v-text-field
                          class="pr-5 mt-0 pt-0 ajuste"
                          v-model="
                            editedItemRequest.fuelRequests[0].fuel_liters
                          "
                          label="Litros de gasolina inicial"
                          type="number"
                          step="1"
                          :disabled="
                            editIsVehicle &&
                            editedIndex !== -1 &&
                            editedItemRequest.status !== 'APPROVED'
                          "
                        />
                      </v-flex>
                      <v-flex md3>
                        <v-text-field
                          class="pr-5 mt-0 pt-0 ajuste"
                          v-model="
                            editedItemRequest.fuelRequests[0].final_liters
                          "
                          label="Litros de gasolina final"
                          type="number"
                          step="1"
                          :disabled="
                            editIsVehicle &&
                            editedIndex !== -1 &&
                            editedItemRequest.status !== 'APPROVED'
                          "
                        />
                      </v-flex>
                      <v-flex
                        md3
                        v-if="editedItemRequest.status === 'APPROVED'"
                      >
                        <v-btn @click="putRequest" depressed color="primary"
                          >Guardar</v-btn
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout
                      v-if="
                        editedItemRequest.is_vehicle &&
                        editedItemRequest.fuelRequests.length > 0
                      "
                    >
                      <v-flex md12>
                        <v-textarea
                          :disabled="editIsVehicle && editedIndex !== -1"
                          v-model="
                            editedItemRequest.fuelRequests[0].description
                          "
                          label="Descripción de viaje"
                          :error-messages="errors.comment"
                          rows="2"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex md12 class="mt-2">
                    <h3 class="font-weight-black primary--text mb-0">
                      {{ $t('general.categories') }}
                      <span
                        md1
                        v-if="
                          editedIndex !== -1 && statusRequestEdit === 'CREATED'
                        "
                      >
                        <v-btn
                          icon
                          small
                          :color="editCategories ? 'primary' : 'grey'"
                          @click="editCategories = !editCategories"
                        >
                          <v-icon small>{{
                            editCategories ? 'mdi-pencil' : 'mdi-pencil-off'
                          }}</v-icon>
                        </v-btn>
                      </span>
                    </h3>
                    <v-layout>
                      <v-flex v-if="categoryRulesAlert === true">
                        <v-alert
                          :value="true"
                          color="error"
                          icon="warning"
                          outline
                          dense
                        >
                          <span class="h6"
                          >
                            {{ $t('viatics.validationCategoryRequiredAlert') }}
                          </span>
                        </v-alert>
                      </v-flex>
                      <v-flex class="text-right">
                        <v-btn
                          color="primary"
                          @click="addCategorie"
                          :disabled="editCategories && editedIndex > -1"
                          >{{ $t('viatics.addCategorie') }}</v-btn
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-form
                        lazy-validation
                        ref="categoriesForm"
                        v-model="categoriesForm"
                      >
                        <!-- DATA TABLE CATEGORIAS -->
                        <v-data-table
                          :headers="categoriesHeader"
                          :items="categoriesSelected"
                          :loading="loadTableCategories"
                          loading-text="Cargando contenido"
                          :footer-props="{ 'items-per-page-options': [-1] }"
                          hide-default-footer
                          no-data-text="No hay datos que mostrar"
                          :pagination.sync="pagination2"
                          :rows-per-page-items="[10, 15, 25]"
                          disable-pagination
                          hide-actions
                        >
                          <template v-slot:items="props">
                            <tr>
                              <td class="text-sm-left text-truncate" style="max-width: 160px">
                                <v-autocomplete
                                  class="text-sm-center"
                                  v-model="props.item.categories_id"
                                  item-text="name"
                                  item-value="id"
                                  hide-details
                                  :rules="rules.required"
                                  :items="categories"
                                  chips
                                  small-chips
                                  color="primary"
                                  :disabled="
                                    editCategories && editedIndex !== -1
                                  "
                                />
                                <!-- {{ props.item.name }} -->
                              </td>
                              <td>
                                <v-text-field
                                  outlined
                                  dense
                                  :hide-details="true"
                                  class="text-sm-center"
                                  color="primary"
                                  v-model="props.item.price"
                                  min="0"
                                  type="number"
                                  :rules="rules.positiveNumber"
                                  @change="getAmount(props.item, props.index)"
                                  :disabled="
                                    editCategories && editedIndex !== -1
                                  "
                                />
                              </td>
                              <td>
                                <v-text-field
                                  class="text-sm-center"
                                  outlined
                                  dense
                                  :hide-details="true"
                                  color="primary"
                                  v-model="props.item.quantity"
                                  min="0"
                                  type="number"
                                  :rules="rules.positiveNumber"
                                  :disabled="
                                    editCategories && editedIndex !== -1
                                  "
                                  @change="getAmount(props.item, props.index)"
                                />
                              </td>
                              <td>
                                <v-textarea
                                  rows="1"
                                  auto-grow
                                  class="text-sm-center"
                                  outlined
                                  dense
                                  :hide-details="true"
                                  color="primary"
                                  v-model="props.item.comment"
                                  type="text"
                                  :disabled="
                                    editCategories && editedIndex !== -1
                                  "
                                />
                              </td>
                              <td>
                                <v-text-field
                                  outlined
                                  dense
                                  :hide-details="true"
                                  :disabled="
                                    editCategories && editedIndex !== -1
                                  "
                                  class="text-sm-center"
                                  color="primary"
                                  v-model="props.item.number_people"
                                  min="0"
                                  type="number"
                                  :rules="rules.positiveNumber"
                                />
                              </td>
                              <td>
                                <v-menu
                                  v-model="props.item.start"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  lazy
                                  transition="scale-transition"
                                  offset-y
                                  full-width
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      :disabled="
                                        editCategories && editedIndex !== -1 ||
                                        !editedItemRequest.start_date || !editedItemRequest.end_date
                                      "
                                      clearable
                                      required
                                      hide-details
                                      :rules="rules.required"
                                      :error-messages="errors.start_date"
                                      v-model="props.item.start_date"
                                      :label="$t('general.startDate')"
                                      readonly
                                      v-on="on"
                                    >
                                    </v-text-field>
                                  </template>
                                  <v-date-picker
                                    color="primary"
                                    :locale="$t('general.locale')"
                                    v-model="props.item.start_date"
                                    :min="editedItemRequest.start_date || props.item.end_date && props.item.end_date"
                                    :max="editedItemRequest.end_date || props.item.end_date ? props.item.end_date : null"
                                    @input="props.item.start = false"
                                    @change="changeDateEndCategory(props.item, props.index)"
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </td>
                              <td>
                                <v-menu
                                  v-model="props.item.end"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  lazy
                                  transition="scale-transition"
                                  offset-y
                                  full-width
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      :disabled="
                                        editCategories && editedIndex !== -1 ||
                                        !editedItemRequest.start_date || !editedItemRequest.end_date
                                      "
                                      clearable
                                      required
                                      hide-details
                                      :rules="rules.required"
                                      :error-messages="errors.start_date"
                                      v-model="props.item.end_date"
                                      :label="$t('general.endDate')"
                                      readonly
                                      v-on="on"
                                    >
                                    </v-text-field>
                                  </template>
                                  <v-date-picker
                                    color="primary"
                                    :locale="$t('general.locale')"
                                    v-model="props.item.end_date"
                                    :min="editedItemRequest.start_date || props.item.start_date ? props.item.start_date : null"
                                    :max="editedItemRequest.end_date"
                                    @input="props.item.end = false"
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </td>
                              <td>
                                <v-text-field
                                  class="text-sm-center mb-1"
                                  outlined
                                  dense
                                  :hide-details="true"
                                  color="primary"
                                  v-model="props.item.amount"
                                  :disabled="
                                    editCategories && editedIndex !== -1
                                  "
                                  type="number"
                                  min="0"
                                  :rules="rules.required"
                                />
                              </td>
                              <td>
                                <v-btn
                                  :disabled="
                                    editedItemRequest.status === 'APPROVED' ||
                                    editCategories && editedIndex !== -1
                                  "
                                  @click="deleteCategorie(props.index)"
                                  icon
                                >
                                  <v-icon color="red">mdi-delete</v-icon>
                                </v-btn>
                              </td>
                            </tr>
                          </template>
                          <template v-slot:footer>
                            <tr>
                              <td colspan="6" class="text-sm-right">
                                <span class="h6 primary--text text-uppercase font-weight-black">{{ $t('general.total') }}:</span>
                              </td>
                              <td colspan="2" class="primary mt-2">
                                <span class="h6 font-weight-black white--text">{{ getTotal | formatCurrency }} MXN</span>
                              </td>
                            </tr>
                            <tr v-if="amountExtension > 0" style="border-top: 0px">
                              <td colspan="6" class="text-sm-right">
                                <span class="h6 primary--text text-uppercase font-weight-black">{{ $t('general.total') }} + {{ $t('viatics.extension') }}:</span>
                              </td>
                              <td colspan="2" class="primary mt-2">
                                <span class="h6 font-weight-black white--text">{{ amountExtension | formatCurrency }} MXN</span>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-form>
                    </v-layout>

                    <!-- INICIO AMPLIACIONES -->
                    <v-flex class="text-right">
                      <v-btn
                        v-if="
                          editedItemRequest.status === 'APPROVED' &&
                          showBtnAddExtension
                        "
                        color="primary"
                        depressed
                        @click="addExtension"
                        :disabled="
                          editedItemRequest.gst_expense && editedItemRequest.gst_expense.status === 2 ||
                          editedItemRequest.status === 'APPROVED' && extensionHandlerValidation(editedItemRequest)
                        "
                        >{{ $t('viatics.addExtras') }}</v-btn
                      >
                    </v-flex>
                    <v-flex class="d-flex flex-row" v-if="editedItemRequest.status === 'APPROVED' && extensionHandlerValidation(editedItemRequest)">
                      <v-spacer></v-spacer>
                      <v-alert
                        :value="true"
                        color="warning"
                        icon="priority_high"
                        outline
                        dense
                      >
                        <span class="h6"
                        >
                          {{ $t('viatics.validationExtensionAlert') }}
                        </span>
                      </v-alert>
                    </v-flex>
                    <v-flex class="d-flex flex-row" v-if="editedItemRequest.gst_expense && editedItemRequest.gst_expense.status === 2">
                      <v-spacer></v-spacer>
                      <v-alert
                        :value="true"
                        color="warning"
                        icon="priority_high"
                        outline
                        dense
                      >
                        <span class="h6"
                        >
                          {{ $t('viatics.warningAddExtension') }}
                        </span>
                      </v-alert>
                    </v-flex>
                    <!-- BOTONES -->
                    <section v-for="(item, index) in editedItemRequest.extensions" :key="index" :class="item.status === 'REJECTED' ? 'custom-bg' : ''" >
                      <!-- ÁREA DE BOTÓN SUPERIOR DE LA TABLA DE CATEGORÍAS DE AMPLIACIONES -->
                      <v-layout>
                        <v-flex v-if="categoryExtensionRulesAlert === true">
                          <v-alert
                            :value="true"
                            color="error"
                            icon="warning"
                            outline
                            dense
                          >
                            <span class="h6"
                            >
                              {{ $t('viatics.validationExtensionRequiredAlert') }}
                            </span>
                          </v-alert>
                        </v-flex>
                        <v-flex class="text-right">
                          <!-- AGREGAR CATEGORIA -->
                          <v-btn
                            v-if="item.status === ''"
                            color="primary"
                            @click="addCategorieExtensions"
                            >{{ $t('viatics.addCategorie') }}</v-btn
                          >
                        </v-flex>
                      </v-layout>

                      <!-- Datos cabecera -->
                      <v-layout class="d-flex justify-end" v-if="editedItemRequest.extensions.length > 0">
                        <v-flex md2 class="mr-3 text-center d-flex justify-content-center align-items-center" v-if="item.folio">
                          <div class="text-container">
                            <b>
                              <span>{{ $t('viatics.extension') }} - No.{{ extensionNumberGenerator(item, editedItemRequest.extensions) }}</span>
                            </b>
                            <b v-if="item.status === 'REJECTED'" style="color:red" class="font-weight-black">
                              {{ $t('expenses.status.rejected') }}
                            </b>
                          </div>
                        </v-flex>
                        <v-flex md2 class="mr-3" v-if="item.folio">
                          <v-text-field
                            v-model="item.folio"
                            required
                            hide-details
                            :rules="rules.required"
                            :error-messages="errors.start_date"
                            :label="$t('general.folio')"
                            readonly
                            :disabled="
                              item.status === 'APPROVED' ||
                              item.status === 'REJECTED' ||
                              item.status === 'IN_REVIEW'
                            "
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex
                          md2
                          class="mr-3"
                          v-if="
                            item.status &&
                            (item.status === 'APPROVED' ||
                              item.status === 'REJECTED' ||
                              item.status === 'IN_REVIEW')
                          "
                        >
                          <v-text-field
                            :value="getStatusSpanish(item.status)"
                            required
                            hide-details
                            :rules="rules.required"
                            :error-messages="errors.start_date"
                            :label="$t('general.status')"
                            readonly
                            :disabled="
                              item.status === 'APPROVED' ||
                              item.status === 'REJECTED' ||
                              item.status === 'IN_REVIEW'
                            "
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex md3 class="mr-3">
                          <v-text-field
                            v-model="item.current_date"
                            disabled
                            required
                            hide-details
                            :rules="rules.required"
                            :error-messages="errors.start_date"
                            :label="$t('general.startDate')"
                            readonly
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex md3>
                          <v-menu
                            v-model="item.end"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="item.end_date"
                                :error="endFieldError"
                                clearable
                                required
                                hide-details
                                :rules="rules.required"
                                :error-messages="errors.start_date"
                                :label="$t('general.selectEndDate')"
                                :disabled="
                                  item.status === 'APPROVED' ||
                                  item.status === 'REJECTED' ||
                                  item.status === 'IN_REVIEW'
                                "
                                readonly
                                v-on="on"
                              >
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="item.end_date"
                              color="primary"
                              :locale="$t('general.locale')"
                              :min="item.current_date"
                              @input="item.end = false"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>

                      <!-- TABLA DE AMPLIACIONES -->
                      <v-layout v-if="editedItemRequest.extensions.length > 0">
                        <v-form
                          lazy-validation
                          ref="formExtensions"
                          v-model="extensionsValid"
                        >
                          <v-data-table
                            :class="item.status === 'REJECTED' ? 'custom-bg' : ''"
                            :headers="categoriesHeaderExtension"
                            :items="item.categories"
                            :loading="loadTableCategories"
                            loading-text="Cargando contenido"
                            :footer-props="{ 'items-per-page-options': [-1] }"
                            hide-default-footer
                            no-data-text="No hay datos que mostrar"
                            :pagination.sync="pagination2"
                            :rows-per-page-items="[10, 15, 25]"
                            disable-pagination
                            hide-actions
                          >
                          <template v-slot:headers="props">
                            <tr class="v-table theme--light" >
                              <th v-for="header in props.headers" :key="header.text" :class="item.status === 'REJECTED' ? 'custom-bg' : ''">
                                  {{ header.text }}
                              </th>
                            </tr>
                          </template>
                            <template  v-slot:items="props">
                              <tr :class="item.status === 'REJECTED' ? 'custom-bg' : ''">
                                <td class="text-sm-left text-truncate" style="max-width: 160px">
                                  <v-autocomplete
                                    class="ajuste"
                                    v-model="props.item.categories_id"
                                    item-text="name"
                                    item-value="id"
                                    hide-details
                                    :rules="rules.required"
                                    :items="categories"
                                    :disabled="
                                      item.status === 'APPROVED' ||
                                      item.status === 'REJECTED' ||
                                      item.status === 'IN_REVIEW' ||
                                      editedItemExtensions === true
                                    "
                                    chips
                                    small-chips
                                    color="primary"
                                  />
                                  <!-- {{ props.item.name }} -->
                                </td>
                                <td>
                                  <v-text-field
                                    outlined
                                    dense
                                    :hide-details="true"
                                    class="text-sm-center"
                                    color="primary"
                                    v-model="props.item.price"
                                    min="0"
                                    type="number"
                                    :rules="rules.positiveNumber"
                                    :disabled="
                                      item.status === 'APPROVED' ||
                                      item.status === 'REJECTED' ||
                                      item.status === 'IN_REVIEW' ||
                                      editedItemExtensions === true
                                    "
                                    @change="
                                      getAmountExtension(
                                        props.item,
                                        props.index
                                      )
                                    "
                                  />
                                </td>
                                <td>
                                  <v-text-field
                                    class="text-sm-center"
                                    outlined
                                    dense
                                    :hide-details="true"
                                    color="primary"
                                    v-model="props.item.quantity"
                                    min="0"
                                    type="number"
                                    :rules="rules.positiveNumber"
                                    :disabled="
                                      item.status === 'APPROVED' ||
                                      item.status === 'REJECTED' ||
                                      item.status === 'IN_REVIEW' ||
                                      editedItemExtensions === true
                                    "
                                    @change="
                                      getAmountExtension(
                                        props.item,
                                        props.index
                                      )
                                    "
                                  />
                                </td>
                                <td>
                                  <v-textarea
                                    rows="1"
                                    auto-grow
                                    class="text-sm-center"
                                    outlined
                                    dense
                                    :hide-details="true"
                                    color="primary"
                                    v-model="props.item.comment"
                                    type="text"
                                    :disabled="
                                      item.status === 'APPROVED' ||
                                      item.status === 'REJECTED' ||
                                      item.status === 'IN_REVIEW' ||
                                      editedItemExtensions === true
                                    "
                                  />
                                </td>
                                <td>
                                  <v-text-field
                                    outlined
                                    dense
                                    :hide-details="true"
                                    :disabled="
                                      item.status === 'APPROVED' ||
                                      item.status === 'REJECTED' ||
                                      item.status === 'IN_REVIEW' ||
                                      editedItemExtensions === true
                                    "
                                    class="text-sm-center"
                                    color="primary"
                                    v-model="props.item.number_people"
                                    min="0"
                                    type="number"
                                    :rules="rules.positiveNumber"
                                  />
                                </td>
                                <td>
                                  <v-menu
                                    v-model="props.item.start"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        clearable
                                        required
                                        hide-details
                                        :rules="rules.required"
                                        :error-messages="errors.start_date"
                                        v-model="props.item.start_date"
                                        :label="$t('general.startDate')"
                                        :disabled="
                                          item.status === 'APPROVED' ||
                                          item.status === 'REJECTED' ||
                                          item.status === 'IN_REVIEW' ||
                                          editedItemExtensions === true ||
                                          !item.end_date
                                        "
                                        readonly
                                        v-on="on"
                                      >
                                      </v-text-field>
                                    </template>
                                    <v-date-picker
                                      color="primary"
                                      :locale="$t('general.locale')"
                                      v-model="props.item.start_date"
                                      :min="item.current_date || props.item.end_date && props.item.end_date"
                                      :max="props.item.end_date ? props.item.end_date : null || item.end_date"
                                      @input="props.item.start = false"
                                      @change="changeDateEndCategoryExtension(item.categories, props.item, props.index)"
                                    >
                                    </v-date-picker>
                                  </v-menu>
                                </td>
                                <td>
                                  <v-menu
                                    v-model="props.item.end"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        clearable
                                        required
                                        hide-details
                                        :rules="rules.required"
                                        :error-messages="errors.end_date"
                                        v-model="props.item.end_date"
                                        :label="$t('general.endDate')"
                                        :disabled="
                                          item.status === 'APPROVED' ||
                                          item.status === 'REJECTED' ||
                                          item.status === 'IN_REVIEW' ||
                                          editedItemExtensions === true ||
                                          !item.end_date
                                        "
                                        readonly
                                        v-on="on"
                                      >
                                      </v-text-field>
                                    </template>
                                    <v-date-picker
                                      color="primary"
                                      :locale="$t('general.locale')"
                                      v-model="props.item.end_date"
                                      :min="item.current_date || props.item.start_date ? props.item.start_date : null"
                                      :max="item.end_date"
                                      @input="props.item.end = false"
                                    >
                                    </v-date-picker>
                                  </v-menu>
                                </td>
                                <td>
                                  <v-text-field
                                    class="text-sm-center mb-1"
                                    outlined
                                    dense
                                    :hide-details="true"
                                    color="primary"
                                    v-model="props.item.amount"
                                    type="number"
                                    min="0"
                                    :disabled="
                                      item.status === 'APPROVED' ||
                                      item.status === 'REJECTED' ||
                                      item.status === 'IN_REVIEW' ||
                                      editedItemExtensions === true
                                    "
                                    :rules="rules.required"
                                  />
                                </td>
                                <td>
                                  <v-btn
                                    @click="deleteExtension(props.index, item.categories)"
                                    :disabled="
                                      item.status === 'APPROVED' ||
                                      item.status === 'REJECTED' ||
                                      item.status === 'IN_REVIEW' ||
                                      editedItemExtensions === true
                                    "
                                    icon
                                  >
                                    <v-icon color="red">mdi-delete</v-icon>
                                  </v-btn>
                                </td>
                              </tr>
                            </template>
                            <template v-slot:footer>
                              <tr :class="item.status === 'REJECTED' ? 'custom-bg' : ''">
                                <td  colspan="6" class="text-sm-right">
                                <span style="color:red" class='' :class="item.status === 'REJECTED' ? 'h6 text-uppercase font-weight-black' : 'h6 primary--text text-uppercase font-weight-black'">
                                  {{ $t('general.total') }} {{ $t('viatics.extension') }} - No.{{ extensionNumberGenerator(item, editedItemRequest.extensions) }}:
                                </span>
                              </td>
                              <td colspan="2" :class="item.status === 'REJECTED' ? 'custom-bg mt-2' : 'primary mt-2'" >
                                <span :class="item.status === 'REJECTED' ? 'h6 text-uppercase font-weight-black white--text' : 'h6 font-weight-black white--text'">
                                  {{ getTotalExtensions(item) | formatCurrency }} MXN
                                </span>
                              </td>
                              <td colspan="1"></td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-form>
                      </v-layout>

                      <!-- ÁREA DE BOTÓN DEBAJO DEL TOTAL DE LA TABLA DE CATEGORÍAS DE AMPLIACIONES -->
                      <v-layout>
                        <v-flex class="text-right">
                          <!-- GUARDAR AMPLIACIONES  -->
                          <v-btn
                            v-if="item.status === ''"
                            color="primary"
                            @click="saveExtensions(index)"
                            :disabled="editedItemExtensions === true"
                            >{{ $t('viatics.saveExtras') }}</v-btn
                          >
                          <v-btn
                            v-if="item.status === ''"
                            color="primary"
                            @click="cancelExtensions(index)"
                            :disabled="editedItemExtensions === false"
                            >{{ $t('general.cancel') }}</v-btn>
                        </v-flex>
                      </v-layout>

                      <!-- ANTICIPO -->
                      <v-layout class="d-flex justify-end" v-if="editedItemRequest.extensions.length > 0">
                        <v-flex md9>
                          <v-checkbox
                            v-model="item.is_advance"
                            :true-value="1"
                            :false-value="0"
                            @change="calculateTotalExtensions"
                            :error-messages="errors.is_refund"
                            :label="$t('viatics.advanceQuestion')"
                            :disabled="
                              item.status === 'APPROVED' ||
                              item.status === 'REJECTED' ||
                              item.status === 'IN_REVIEW' ||
                              editedItemExtensions === true
                            "
                          >
                          </v-checkbox>
                        </v-flex>
                        <v-flex md3>
                          <v-text-field
                            v-if="item.is_advance"
                            clearable
                            width="30px"
                            class="ml-3"
                            min="0"
                            required
                            :rules="rules.required"
                            :error-messages="errors.has_advance"
                            v-model="item.amount_advance"
                            type="number"
                            :disabled="
                              item.status === 'APPROVED' ||
                              item.status === 'REJECTED' ||
                              item.status === 'IN_REVIEW' ||
                              editedItemExtensions === true
                            "
                          />
                        </v-flex>
                      </v-layout>

                      <v-layout class="d-flex justify-end" v-if="editedItemRequest.extensions.length > 0">
                        <v-flex
                          md6
                          class="text-right"
                          v-if="
                            status === 'IN_REVIEW' &&
                            isValidator() &&
                            item.status === 'IN_REVIEW'
                          "
                        >
                          <v-btn
                            round
                            depressed
                            color="#73D673"
                            class="ma-2 white--text"
                            :loading="loadingChangeStatusExtension"
                            @click="showViaticsAceptedExtension(index)"
                          >
                            {{ $t('viatics.validateExtension') }}
                          </v-btn>
                          <v-btn
                            flat
                            color="#F7665E"
                            class="ma-2"
                            :loading="loadingChangeStatusExtension"
                            @click="
                              changeStatusExtension(
                                editedItemRequest,
                                'REJECTED',
                                index
                              )
                            "
                          >
                            {{ $t('viatics.rejectExtension') }}
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </section>
                    <!-- FIN AMPLIACIONES -->
                    <br/>
                    <v-layout>
                      <v-flex md4>
                        <v-radio-group v-model="editedItemRequest.has_advance" @change="changeAdvance">
                          <v-radio :label="`Caja chica / Tarjeta AMEX`" :value="`caja_chica`"></v-radio>
                          <v-radio :label="`Anticipo`" :value="`anticipo`"></v-radio>
                          <v-radio :label="`Reembolso`" :value="`reembolso`"></v-radio>
                        </v-radio-group>
                      </v-flex>
                      <v-flex md4>
                        <vue-dropzone
                          v-if="editedItemRequest.id === null || (editedItemRequest.attachments.length < 5 && editedItemRequest.status === 'CREATED')"
                          ref="dropzone" id="dropzone" :options="dropzoneOptions"
                          v-on:vdropzone-file-added="fileAdded"
                          v-on:vdropzone-error="fileUploadError"
                          v-on:vdropzone-success="fileUpload"
                          :key="dropzoneKey">
                        </vue-dropzone>
                      </v-flex>
                      <v-flex md4>
                        <v-text-field
                          clearable
                          width="30px"
                          class="ml-3"
                          required
                          :rules="rules.required"
                          prepend-icon="attach_money"
                          :error-messages="errors.totalAmount"
                          min="0"
                          type="number"
                          v-model="editedItemRequest.totalAmount"
                          :disabled="editTotalAmount && editedIndex !== -1"
                        />
                      </v-flex>
                      <v-flex md1 v-if="editedIndex !== -1 && statusRequestEdit === 'CREATED'">
                        <v-btn icon :color="editTotalAmount ? 'primary' : 'grey'" @click="editTotalAmount = !editTotalAmount">
                          <v-icon>{{ editTotalAmount ? 'mdi-pencil' : 'mdi-pencil-off' }}</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex xs12>
                        <h3 class="primary--text font-weight-black">{{$t('expenses.files')}}:</h3>
                      </v-flex>
                      <v-flex v-if="editedItemRequest.attachments.length > 0">
                        <v-btn v-for="file in editedItemRequest.attachments" :key="file.id" color="primary" dark @click="watchFile(file.file)">
                          <v-icon left v-if="file.file.files_type_id === 9 || file.file.files_type_id === 12">fas fa-file-archive</v-icon>
                          <v-icon left v-else-if="file.file.files_type_id === 3">description</v-icon>
                          <v-icon left v-else>insert_photo</v-icon>
                          <h3 class="pb-0 mb-0">{{$t('expenses.file')}} {{file.file_id}}</h3>
                        </v-btn>
                      </v-flex>
                      <v-flex v-else-if="editedItemRequest.id > 0">
                        <v-alert color="info" outline :value="true" icon="info"> {{$t('expenses.noFiles')}} </v-alert>
                      </v-flex>
                    </v-layout>
                    <v-layout v-if="false">
                      <v-flex md11>
                        <v-checkbox
                          v-model="editedItemRequest.has_advance"
                          :error-messages="errors.is_refund"
                          :disabled="editAdvance && editedIndex !== -1"
                          :label="$t('viatics.advanceQuestion')"
                        >
                        </v-checkbox>
                        <v-text-field
                          v-if="editedItemRequest.has_advance"
                          clearable
                          width="30px"
                          class="ml-3"
                          min="0"
                          required
                          :rules="rules.required"
                          :error-messages="errors.has_advance"
                          v-model="editedItemRequest.advance"
                          :disabled="editAdvance && editedIndex !== -1"
                          type="number"
                        />
                      </v-flex>
                      <v-flex
                        md1
                        v-if="
                          editedIndex !== -1 && statusRequestEdit === 'CREATED'
                        "
                      >
                        <v-btn
                          icon
                          :color="editAdvance ? 'primary' : 'grey'"
                          @click="editAdvance = !editAdvance"
                        >
                          <v-icon>{{
                            editAdvance ? 'mdi-pencil' : 'mdi-pencil-off'
                          }}</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <div
                      v-if="
                        status === 'APPROVED' &&
                        parseFloat(editedItemRequest.amount_authorized) > 0
                      "
                      class="subtitle-1 mt-2"
                    >
                      {{ $t('viatics.amountAuthorized') }}
                    </div>
                    <v-layout
                      v-if="
                        status === 'APPROVED' &&
                        parseFloat(editedItemRequest.amount_authorized) > 0
                      "
                    >
                      <v-text-field
                        clearable
                        width="30px"
                        class="ml-3"
                        required
                        prepend-icon="attach_money"
                        :error-messages="errors.amount_authorized"
                        v-model="editedItemRequest.amount_authorized"
                        min="0"
                        :disabled="true"
                      />
                    </v-layout>
                    <div class="subtitle-1 mt-2">
                      {{ $t('viatics.validators') }} :
                    </div>
                    <v-layout >
                      <v-flex md11>
                        <v-autocomplete
                          v-model="editedItemRequest.validator_id"
                          item-text="name"
                          item-value="id"
                          required
                          :rules="rules.required"
                          :error-messages="errors.validator_id"
                          :items="filterValidators"
                          color="primary"
                          :disabled="status === 'APPROVED' || (editApprovers && editedIndex !== -1)"
                        />
                      </v-flex>
                      <v-flex
                        md1
                        v-if="editedIndex !== -1 && (status === undefined || status === 'CREATED' || status === 'REJECTED')"
                      >
                        <v-btn
                          icon
                          :disabled="editedItemRequest.status === 'APPROVED'"
                          :color="editApprovers ? 'primary' : 'grey'"
                          @click="editApprovers = !editApprovers"
                        >
                          <v-icon>{{
                            editApprovers ? 'mdi-pencil' : 'mdi-pencil-off'
                          }}</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <div v-if="status === 'REJECTED'" class="subtitle-1 mt-2">
                      {{ $t('viatics.reasonRejected') }}:
                    </div>
                    <v-layout v-if="status === 'REJECTED'">
                      <v-flex
                        xs12
                        class="pa-2 mt-3"
                        style="background-color: #f7665e; border-radius: 5px"
                      >
                        <v-icon small class="mb-1" color="#FFF"
                          >fas fa-thumbs-down</v-icon
                        >
                        <p>
                          <strong>{{ editedItemRequest.comment }}</strong>
                        </p>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      class="d-flex justify-start my-4"
                      v-if="status === 'IN_REVIEW' || status === 'APPROVED'"
                    >
                      <v-flex md9>
                        <span
                          class="
                            h6
                            font-weight
                          "
                          >{{ $t('viatics.totalAmountAdvance') }}:</span
                        >
                        <span class="h6"
                        >
                          {{ advanceCalculate(editedItemRequest, editedItemRequest.amount_advance) | formatCurrency }} MXN
                        </span>
                      </v-flex>
                      <v-flex md3>
                      </v-flex>
                    </v-layout>
                    <div
                      v-if="
                        status === 'APPROVED' &&
                        editedItemRequest.comment !== null
                      "
                      class="subtitle-1 mt-2"
                    >
                      {{ $t('viatics.validationMessage') }}:
                    </div>
                    <v-layout
                      v-if="
                        status === 'APPROVED' &&
                        editedItemRequest.comment !== null
                      "
                    >
                      <v-flex
                        xs12
                        class="pa-2 mt-3"
                        style="background-color: #73d673; border-radius: 5px"
                      >
                        <v-icon small class="mb-1" color="#FFF"
                          >fas fa-thumbs-up</v-icon
                        >
                        <p>
                          <strong>{{ editedItemRequest.comment }}</strong>
                        </p>
                      </v-flex>
                    </v-layout>
                    <v-layout class="mt-5" v-if="editedIndex !== -1">
                      <v-flex>
                        {{ $t('viatics.downloadRequest') }}
                        <v-btn
                          class="mr-0"
                          :loading="loadingDownload === 'pdf'"
                          icon
                          flat
                          color="error"
                          @click="downloadRequest('pdf')"
                        >
                          <v-icon dark> mdi-file-pdf-box </v-icon>
                        </v-btn>
                        <v-btn
                          class="ml-0"
                          :loading="loadingDownload === 'xls'"
                          icon
                          flat
                          color="green"
                          @click="downloadRequest('xls')"
                        >
                          <v-icon dark> mdi-file-excel-box</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" round flat @click="close">
              {{
                status === undefined || status === 'IN_REVIEW'
                  ? statusRequestEdit === 'APPROVED' && editedItemExtensions === false
                    ? $t('general.close')
                    : $t('general.cancel')
                  : $t('general.close')
              }}
            </v-btn>
            <div v-if="statusRequestEdit !== 'APPROVED'">
              <v-btn
                v-if="status === undefined || status === 'CREATED' || status === 'REJECTED'"
                color="primary"
                round
                class="white--text"
                depressed
                :loading="loading"
                :disabled="loading"
                @click="saveRequest"
              >
                {{ $t('general.create') }}
              </v-btn>
            </div>
            <div v-if="statusRequestEdit === 'APPROVED'">
            <v-btn
              color="primary"
              round
              class="white--text"
              depressed
              :loading="loadingSaveExtensions"
              :disabled="loadingSaveExtensions || editedItemExtensions === false"
              @click="sendExtensions"
            >
              {{ $t('general.submit') }}
            </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="dialogDeleteRequest" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">
              {{ $t('viatics.deleteTitle') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>
              {{ $t('viatics.deleteQuestion')
              }}<strong>: {{ editedItemRequest.folio }}</strong
              >{{ '?' }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="dialogDeleteRequest = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="deleteRequest()"
            >
              {{ $t('viatics.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- DIALOGO DESCRIPCION ADICIONALES -->
      <v-dialog
        v-model="descriptionExtensionDialog"
        max-width="500px"
        persistent
      >
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('viatics.addDescription') }}
            </h2>
          </v-toolbar>
          <v-card-text>
            <v-textarea
              v-model="commentExtense.comment"
              :error-messages="errors.comment"
              :disabled="commentExtense.disabled || editedItemExtensions === true"
              rows="2"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              round
              flat
              @click="descriptionExtensionDialog = false"
              >{{ $t('general.cancel') }}</v-btn
            >
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="primary"
              round
              depressed
              @click="saveDescriptionDialogExtense"
              >{{ $t('general.accept') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <ReservationModalCashier
        v-if="dialogRelationsChashier"
        :dialog="dialogRelationsChashier"
        :cashiers="cashiers"
        :cashiersUser="cashiersUser"
        :cashierRelation="cashierRelation"
        :loadingRelation="loadingRelation"
        @getRelations="getRelations"
        @generateRelations="generateRelations"
        @deleteRelation="deleteRelation"
        @cancel="closeDialogCashier"
      />
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import vue2Dropzone from 'vue2-dropzone'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faCalendarDay)
export default {
  name: 'reservationsComponent',
  components: {
    vueDropzone: vue2Dropzone,
    'font-awesome-icon': FontAwesomeIcon,
    ReservationModalCashier: () =>
      import('./reservations/ReservationModalCashier.vue'),
  },
  props: {
    tabActive: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      component : 'reservations',
      loadingSaveExtensions: false,
      showBtnAddExtension: true,
      vehicles: [],
      dialogRelationsChashier: false,
      loadingRelation: false,
      cashiers: [],
      cashiersUser: [],
      cashierRelation: [],
      categories: [],
      satFormaPago: [],
      satMetodoPago: [],
      satMoneda: [],
      satPais: [],
      sumaSubtotal: 0,
      sumaDescuento: 0,
      sumaTotal: 0,
      dialogNF: false,
      dialogF: false,
      cfdiHtml: null,
      dataURL: null,
      workflowName: '',
      histDialog: false,
      pendingValidators: [],
      validatorsExpenses: [],
      validators: [],
      approvers: [],
      isApproved: false,
      descriptionExtensionDialog: false,
      commentExtense: {
        disabled: false,
        index: null,
        comment: null,
      },
      histItem: {
        id: 1,
        description: 'alguna vaina',
        start_date: '',
        end_date: '',
        project: {
          name: '',
        },
        progress: [],
        steps: [
          {
            status: 1,
            validator: [
              {
                id: 1,
                name: 'fulano',
              },
              {
                id: 2,
                name: 'fulano',
              },
            ],
          },
          {
            status: 2,
            validator: [
              {
                id: 1,
                name: 'fulano',
              },
            ],
          },
        ],
      },
      histSteps: {
        sented: [],
        reviewed: [],
        payable: [],
        paid: [],
      },
      histLoading: false,
      isPettyCash: false,
      type: 'refund',
      isDisabledPettyCash: false,
      isDisabledOkBlue: false,
      isDisabledAdvance: false,
      isDisabledRefund: false,
      isDisabledAmexCard: false,
      isDisabledOkBlueEdit: false,
      expenseSearch: '',
      errors: {},
      loading: false,
      loadingItems: true,
      loadingItemsReservations: true,
      pagination: {
        sortBy: 'id',
        descending: true,
        page: 1,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0,
      },
      timeout: 3000,
      dialog: false,
      removeDialog: false,
      workflowDialog: false,
      workflowDialogValidate: false,
      addExpenseDialog: false,
      start: false,
      end: false,
      valid: true,
      editedIndex: -1,
      editedItem: {
        id: null,
        user_id: null,
        start_date: '',
        end_date: '',
        description: '',
        project_id: '',
        status: '',
        expenses_status: '',
        advance: 0,
        user: '',
        petty_cash_type: false,
        type: 'RESERVATION',
        viatic_request_id: null,
        status_advance: 0,
        project_list: [],
        has_multiprojects: false
      },
      editedItemNF: {
        gst_expenses_id: null,
        gst_receipt_types_id: 2,
        date: null,
        gst_categories: {
          name: '',
        },
        gst_categories_id: null,
        is_refund: false,
        description: '',
        exchange: 1,
        subtotal: '',
        total: '',
        country: {
          id: 151,
          descripcion: '',
        },
        currency: {
          id: 100,
          descripcion: '',
        },
        sat_forma_pago: {
          descripcion: '',
        },
        folio: '',
        comment: '',
        fileId: null,
        discount: null,
      },
      defaultItemNF: {
        gst_expenses_id: null,
        gst_receipt_types_id: 2,
        date: null,
        gst_categories: {
          name: '',
        },
        gst_categories_id: null,
        is_refund: false,
        description: '',
        exchange: 1,
        subtotal: '',
        total: '',
        country: {
          id: 0,
          descripcion: '',
        },
        currency: {
          id: 0,
          descripcion: '',
        },
        sat_forma_pago: {
          descripcion: '',
        },
        folio: '',
        comment: '',
        fileId: null,
        discount: null,
      },
      defaultItem: {
        id: null,
        user_id: null,
        start_date: '',
        end_date: '',
        description: '',
        project_id: '',
        status: '',
        expenses_status: '',
        advance: 0,
        user: '',
        petty_cash_type: false,
        viatic_request_id: null,
        fuelRequests: [
          {
            gst_vehicle_id: null,
            description: null,
            initial_milleage: 0,
            fuel_liters: 0,
            final_liters: 0,
            final_milleage: 0
          },
        ],
        project_list: [],
        has_multiprojects: false
      },
      editedItemF: {
        gst_categories: {},
        country: {},
        currency: {},
        sat_forma_pago: {},
        receipt_type: {
          name: 'name',
        },
        sat_metodo_pago: {},
        validator_comment: '',
      },
      userLogged: {},
      employees: [],
      expenses: [],
      expensesStatus: [],
      projects: [],
      start_date: new Date().toISOString().substr(0, 10),
      end_date: new Date().toISOString().substr(0, 10),
      // tabActive: 1,
      viatics: [],
      travelTypes: [],
      users: [],
      status: undefined,
      requestSearch: '',
      dialogRequest: '',
      validApproved: true,
      editDates: true,
      menuApproved: false,
      menu2Approved: false,
      editProject: true,
      editUserAssined: true,
      editDescription: true,
      editIsTravel: true,
      editIsVehicle: true,
      editOrigin: true,
      editDestination: true,
      editTravelType: true,
      editCategories: true,
      categoriesForm: true,
      categoriesSelected: [],
      loadTableCategories: false,
      editAdvance: true,
      editTotalAmount: true,
      editApprovers: true,
      loadingDownload: false,
      validatorsRequest: [],
      dialogDeleteRequest: false,
      statusRequestEdit: '',
      editOrderNumber: true,
      pagination2: {
        descending: false,
        page: 1,
        rowsPerPage: 15,
        totalItems: 0,
      },
      editedItemRequest: {
        folio: '',
        status: null,
        id: null,
        user: {
          id: 0,
          name: '',
        },
        creation_date: new Date().toISOString().substr(0, 10),
        start_date: '',
        end_date: '',
        travel_type: {
          id: null,
          name: '',
        },
        project_id: null,
        description: '',
        origin: '',
        destination: '',
        categories_id: [],
        validator_id: null,
        totalAmount: 0,
        approvers: null,
        validators: [],
        extensions: [],
        categories: [],
        fuelRequests: [
          {
            gst_vehicle_id: null,
            description: null,
            initial_milleage: 0,
            fuel_liters: 0,
            final_liters: 0,
            final_milleage: 0
          },
        ],
        has_advance: false,
        is_travel: false,
        is_vehicle: false,
        amount_authorized: 0,
        advance: 0,
        amount_advance: 0,
        petty_cash_type: 0,
        comment: '',
        assigned_user_id: null,
        attachments:[]
      },
      defaultItemRequest: {
        folio: '',
        status: null,
        id: null,
        user: {
          id: 0,
          name: '',
        },
        creation_date: new Date().toISOString().substr(0, 10),
        start_date: '',
        end_date: '',
        travel_type: {
          id: null,
          name: '',
        },
        project_id: null,
        description: '',
        origin: '',
        destination: '',
        categories_id: [],
        validator_id: null,
        totalAmount: 0,
        approvers: null,
        validators: [],
        categories: [],
        extensions: [],
        fuelRequests: [
          {
            gst_vehicle_id: null,
            description: null,
            initial_milleage: 0,
            fuel_liters: 0,
            final_liters: 0,
            final_milleage: 0
          },
        ],
        has_advance: false,
        is_travel: false,
        is_vehicle: false,
        advance: 0,
        comment: '',
        assigned_user_id: null,
        order_number: null,
        attachments:[]
      },
      requestEditValidate: true,
      extensionsValid: true,
      editedItemExtensions: false,
      categoryRulesAlert: false,
      categoryExtensionRulesAlert: false,
      actionsLoading: false,
      dropzoneOptions: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.defaultMaxFiles', { amount: '5', size: '5', unit: 'MB' }),
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 5,
        resizeWidth: 1080,
        resizeHeight: 1080,
        resizeMethod: 'contain',
        resizeQuality: 0.8,
        paramName: 'path',
        acceptedFiles: '.jpeg,.jpg,.png,.pdf',
        maxFiles: 5,
        headers: {
          Authorization: 'Bearer ' + this.$store.state.userState.access_token,
        },
        params: {
          user_id: this.$store.state.userLogged.id,
          dirname: 'IMG_EXPENSES',
        },
      },
      filesId:[], 
      loadingFile: false,
      loadFile: false,
      dialogViewFile: false,
      dataURLFile: null,
      watchItem: {
        files_type_id: 0,
        id: 0,
        is_public: 0,
        user_id: 0
      },
      viewImg: false,
      dropzoneKey: 0,
      amountExtension: 0,
      gst_expenses_status_id: 1,
      loadingExcelReport: false,
      activeTab: 0,
      disabledTag: false,
      activeTabReserva : 0,
      creatorExpense: {},
      representExpense: {},
      viewVoucherAmount: false,
      openExpenseDialog: true,
      assigned_user_id : 0,
      selectMultiProject: false,
      projectsSecond: [],
      confirmSave: false,
      statusTagCheckReservation: 'CREATED',
      disabledTagCheckReservation: true,
    }
  },
  computed: {
    pendingValidatorsC() {
    if(!this.validators) return []

      let pendingValidatorsA = this.validators
      this.histItem.progress.forEach((item) => {
        pendingValidatorsA = pendingValidatorsA.filter(
          (x) => x.validator.user_id !== item.user_id
        )
      })
      return pendingValidatorsA
    },
    categoriesHeaderExtension() {
      return [
        {
          text: this.$t('viatics.categoryHeader'),
          align: 'center',
          value: 'name',
          sortable: false,
          fixed: true,
        },
        {
          text: this.$t('viatics.approxPrice'),
          align: 'center',
          value: 'price',
          sortable: false,
          fixed: true,
          width: '9%'
        },
        {
          text: this.$t('viatics.abbrQuantity'),
          align: 'center',
          value: 'quantity',
          sortable: false,
          fixed: true,
          width: '4%'
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false,
          fixed: true,
          width: '18%'
        },
        {
          text: this.$t('viatics.abbrNumberPeople'),
          align: 'center',
          value: 'number_people',
          sortable: false,
          fixed: true,
          width: '3%'
        },
        {
          text: this.$t('viatics.dateStart'),
          align: 'center',
          value: 'start_date',
          width: '150px',
          sortable: false,
          fixed: true,
        },
        {
          text: this.$t('viatics.dateEnd'),
          align: 'center',
          value: 'end_date',
          width: '150px',
          sortable: false,
          fixed: true,
        },
        {
          text: this.$t('general.amount'),
          align: 'center',
          value: 'amount',
          sortable: false,
          fixed: true,
          width: '9%'
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          value: 'actions',
          sortable: false,
          fixed: true,
          width: '4%'
        }
      ]
    },
    getLicencePlate() {
      const isVehicleSelected =
      this.editedItemRequest.fuelRequests[0].gst_vehicle_id !== null

      if (isVehicleSelected) {
        return this.vehicles.find(
          (e) => e.id === this.editedItemRequest.fuelRequests[0].gst_vehicle_id
        ).license_plate
      }

      return 'No ha seleccionado un vehículo'
    },
    filteredHeaders() {
      if (this.userLogged.roles && this.userLogged.roles[0].name === 'ADMIN') {
        return this.headers.filter((x) => x.text !== '')
      } else {
        return this.headers
      }
    },
    editable() {
      if (this.editedIndex > -1) {
        if (
          this.editedItem.created_by &&
          this.editedItem.created_by.id !== this.$store.state.userLogged.id
        ) {
          return true
        } else {
          return false
        }
      }
    },
    // filteredExpenses () {
    //   return this.expenses.filter(function (el) {
    //     return el.advance !== '0.00'
    //   })
    // },
    heading() {
      return this.$t('expenses.reservations.title')
    },
    subheading() {
      return ''
    },
    icon() {
      return 'fa fa-calendar-day fa-fw icon-color'
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('expenses.new')
        : this.$t('expenses.edit')
    },
    headers() {
      return [
        {
          text: '',
          align: 'center',
          sortable: false,
        },
        {
          text: "#",
          align: 'center',
          value: 'status_expense.name',
          sortable: true,
        },
        {
          text: this.$t('general.assigned'),
          align: 'center',
          value: 'user.name',
          sortable: true,
        },
        // {
        //   text: this.$t('general.createdBy'),
        //   align: 'center',
        //   value: 'created_by',
        //   sortable: true
        // },
        {
          text: this.$t('setting.st.period'),
          align: 'center',
          value: 'start_date',
          sortable: true,
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: true,
        },
        {
          text: this.$t('general.project'),
          align: 'center',
          value: 'project.name',
          sortable: true,
        },
        {
          text: this.$t('general.advance'),
          align: 'center',
          value: 'advance',
          sortable: true,
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    headersRequest() {
      return [
        {
          text: this.$t('viatics.folio'),
          align: 'left',
          value: 'folio',
          sortable: true,
        },
        {
          text: this.$t('general.assigned'),
          align: 'left',
          value: 'user_assigned.name',
          sortable: true,
        },
        {
          text: this.$t('viatics.requestDate'),
          align: 'center',
          value: 'creation_date',
          sortable: true,
        },
        {
          text: this.$t('general.project'),
          align: 'left',
          value: 'project.name',
          sortable: true,
        },
        {
          text: this.$t('general.advance'),
          align: 'center',
          value: 'advance',
          sortable: true,
        },
        {
          text: this.$t('conciliation.statusLabel'),
          align: 'center',
          value: 'status',
          sortable: true,
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    categoriesHeader() {
      return [
        {
          text: this.$t('viatics.categoryHeader'),
          align: 'center',
          value: 'name',
          sortable: false,
          fixed: true,
        },
        {
          text: this.$t('viatics.approxPrice'),
          align: 'center',
          value: 'price',
          sortable: false,
          fixed: true,
          width: '9%'
        },
        {
          text: this.$t('viatics.abbrQuantity'),
          align: 'center',
          value: 'quantity',
          sortable: false,
          fixed: true,
          width: '4%'
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false,
          fixed: true,
          width: '18%'
        },
        {
          text: this.$t('viatics.abbrNumberPeople'),
          align: 'center',
          value: 'number_people',
          sortable: false,
          fixed: true,
          width: '3%'
        },
        {
          text: 'Fecha inicio',
          align: 'center',
          value: 'start_date',
          width: '150px',
          sortable: false,
          fixed: true,
        },
        {
          text: 'Fecha fin',
          align: 'center',
          value: 'end_date',
          width: '150px',
          sortable: false,
          fixed: true,
        },
        {
          text: this.$t('general.amount'),
          align: 'center',
          value: 'amount',
          sortable: false,
          fixed: true,
          width: '9%'
        },

        {
          text: this.$t('general.actions'),
          align: 'center',
          value: 'actions',
          sortable: false,
          fixed: true,
          width: '4%'
        }
      ]
    },
    rules() {
      return this.$validationRules()
    },
    filterViatics() {
      let filtered = []
      if (this.viatics.length > 0) {
        filtered = this.viatics.filter(
          (viatic) =>
            viatic.project.company_id === this.userLogged.company[0].id
        )
      }
      return filtered
    },
    filteredHeadersRequest() {
      if (this.userLogged.roles && this.userLogged.roles[0].name === 'ADMIN') {
        return this.headersRequest.filter((x) => x.text !== '')
      } else {
        // return this.headersRequest.filter(
        //   (x) => x.text !== this.$t('general.actions')
        // )
        return this.headersRequest
      }
    },
    formTitleRequest() {
      return this.editedIndex === -1
        ? this.$t('viatics.new')
        : this.status !== 'CREATED'
        ? this.$t('viatics.requestDetails')
        : this.$t('viatics.edit')
    },
    maxDate() {
      let maxDate = ''
      if (
        this.editedItemRequest.end_date !== '' &&
        this.editedItemRequest.end_date !== null
      ) {
        maxDate = new Date(this.editedItemRequest.end_date)
          .toISOString()
          .substr(0, 10)
      }
      return maxDate
    },
    getTotal() {
      let total = 0
      this.categoriesSelected.forEach((x) => {
        total +=
          x.amount !== undefined && x.amount !== undefined
            ? parseFloat(x.amount)
            : 0
      })
      return total
    },
    filterValidators() {
      let arrayValidators = []
      //let validators = this.validatorsRequest.filter(
        //(item) =>
          //item.area.company_id === this.userLogged.company[0].id
      //)
      let validators = this.validatorsRequest
      validators.forEach((x) => {
        let validator = {}
        validator.id = x.id
        validator.name = x.user.name
        arrayValidators.push(validator)
      })
      return arrayValidators
    },
    endFieldError() {
      return !this.editedItemRequest.extensions[0].end_date;
    },
    employeesFilter(){
      return this.employees.filter(x => x.active === 1)
    },
    usersFilter(){
      return this.users.filter(x => x.active === 1)
    },
    hasMultiProjects(){
      if(this.$store.state.userLogged && this.$store.state.userLogged.company[0].features.find(x => x.name === 'MULTIPROJECTS')) return true
      
      return false
    }
  },
  watch: {
    'editedItem.project_id'() {
      this.projectsSecond =  this.projects.filter(project => project.id !== this.editedItem.project_id)
    },
    loadingItemsReservations() {
      if(this.loadingItemsReservations === false) this.disabledTag = false
    },
    loadingItems() {
      if(this.loadingItems === false) this.disabledTagCheckReservation = false
    },
    tabActive(){
      this.activeTab = 0
      if(this.tabActive === 1) return this.getRequestTags('CREATED')
      return this.getByStatus(1)
    },
    validators() {
      this.getPendingValidators()
    },
    type() {
      if (this.type === 'pettyCash') {
        this.editedItem.advance = 0
        this.editedItem.petty_cash_type = 1
      } 
      else if (this.type === 'advance') {
        this.editedItem.petty_cash_type = 0
        if(this.editedItem.amount_authorized && this.editedItem.amount_authorized !== 0){
          const amountAuthorized = this.advanceAuthorizedCalculate(this.editedItem, this.editedItem.amount_authorized)
          this.editedItem.advance = amountAuthorized
        }
      } 
      else if (this.type === 'refund') {
        this.editedItem.advance = 0
        this.editedItem.petty_cash_type = 0
      }
      this.viewVoucherAmountCheck()
    },
    dialog(val) {
      val || this.close()
    },
    removeDialog(val) {
      val || this.closeRemove()
    },
    userLogged() {
      if (this.$store.state.userLogged.company !== undefined) {
        this.get()
      }
    },
    getTotal() {
      this.editedItemRequest.totalAmount = this.getTotal
    },
    '$store.state.userLogged'() {
      this.getLogged()
    },
    'editedItemRequest.has_advance'(val) {
      if (val && this.editedIndex === -1) {
        this.editedItemRequest.advance = this.editedItemRequest.totalAmount
      } else if (!val && this.editedIndex === -1) {
        this.editedItemRequest.advance = 0
      }
    },
    'editedItemRequest.validator_id'() {
      // this.editedItemRequest.validators = []
      let filtered = this.filterValidators.find(
        (x) => x.id === this.editedItemRequest.validator_id
      )
      if (filtered !== undefined) {
        let validator = {}
        if (this.editedIndex > -1) {
          validator.id = this.editedItemRequest.validators[0].id
        }
        validator.validators_id = filtered.id
        this.editedItemRequest.validator_id = filtered.id
        this.editedItemRequest.validators = []
        this.editedItemRequest.validators.push(validator)
      }
    },
    'editedItemRequest.categories_id'() {
      let index = 0
      let item = {}
      if (
        this.editedItemRequest.categories_id &&
        this.editedItemRequest.categories_id.length > 0
      ) {
        this.editedItemRequest.categories_id.forEach((x) => {
          let category = this.categories.find(
            (c) => c.id === this.editedItemRequest.categories_id[index]
          )
          if (
            category !== undefined &&
            this.categoriesSelected.find(
              (i) => i.categories_id === category.id
            ) === undefined
          ) {
            item.categories_id = category.id
            // item.id = category.id
            item.price = 0
            item.quantity = 0
            item.amount = 0
            item.name = category.name
            item.comment = ''
            this.categoriesSelected.push(item)
            this.editedItemRequest.categories = this.categoriesSelected
          }
          index++
          item = {}
        })
      }
      let catSelected = this.categoriesSelected
      catSelected.forEach((x) => {
        if (
          this.editedItemRequest.categories_id.find(
            (c) => c === x.categories_id
          ) === undefined
        ) {
          this.categoriesSelected = this.categoriesSelected.filter(
            (i) => i.categories_id !== x.categories_id
          )
          this.editedItemRequest.categories = this.categoriesSelected
        }
      })
    },
    'editedItemRequest.extensions'() {
      const categorieExt = {
        categories_id: null,
        price: 0,
        quantity: 0,
        comment: '',
        amount: 0,
        start_date: '',
        end_date: '',
        number_people: '0',
      }
      if(this.editedItemRequest.extensions[0]) {
        this.editedItemRequest.extensions[0].categories
      }
    },
    '$route.params.type': function () {
      const type = this.$route.params.type

      if (type === 'checks') {
        this.getLogged()
        return
      }

      if (type === 'application') {
        this.getRequestTags('CREATED')
        return
      }
    },
  },
  created() {
    this.getLogged()

    this.$emit('getCashierByCompany', {
      event: {
        context: this,
      },
    })

    this.$emit('getVehicles', { context: this })

    const type = this.$route.params.type
    
    if (type === 'application') {
      this.getRequestTags('CREATED')
      return
    }
  },
  methods: {
    viewAmexCard(item){
      if(!item || item.length === 0) return false
      return item.find(x => x.type === 2)
    },
    viewPettyCash(item){
      if(!item || item.length === 0) return false
      return item.find(x => x.type === 1)
    },
    getPettyCashAmount(item){
      if(!item || item.length === 0) return 0
      return item.find(x => x.type === 1).amount
    },
    getAmexAmount(item){
      if(!item || item.length === 0) return 0
      return item.find(x => x.type === 2).amount
    },
    changeTypeByEmployee(item){
      if(item.small_box.length === 0 && (this.type === 'pettyCash' || this.type === 'amexCard')) {
        return this.type = 'refund'
      }

      if(!item.small_box.find(x => x.type === 1) && this.type === 'pettyCash') {
        return this.type = 'refund'
      }

      if(!item.small_box.find(x => x.type === 2) && this.type === 'amexCard') {
        return this.type = 'refund'
      }
    },
    closeViewFile(){
      this.dialogViewFile = false
      this.loadFile = false
      this.dataURLFile = null
      this.watchItem = {
        files_type_id: 0,
        id: 0,
        is_public: 0,
        user_id: 0
      }
    },
    watchFile (item) {
      this.dialogViewFile = true
      this.watchItem = item
      this.loadFile = true
      if (item.files_type_id === 9 || item.files_type_id === 12) {
        this.$store.dispatch('getZip', {
          event: {
            context: this,
            fileId: item.id
          }
        })
      } else {
        this.$store.dispatch('getFile', {
          event: {
            context: this,
            fileId: item.id
          }
        })
      }
    },
    fileAdded(file) {
      this.dropzoneOptions.params.user_id = this.$store.state.userLogged.id
      let fileType = file.type
      if (fileType === 'image/jpeg' || fileType === 'image/jpg') {
        this.dropzoneOptions.params.files_type_id = 5
      } else if (fileType === 'image/png') {
        this.dropzoneOptions.params.files_type_id = 6
      } else if (fileType === 'application/pdf') {
        this.dropzoneOptions.params.files_type_id = 3
      }
    },
    fileUploadError(file, message, xh) {
      this.showNotification(message + '. ' +  this.$t('dropzone.limitedFiles', { nameFile: file.name }), 'error', -1)
    },
    fileUpload(file, response) {
      if(this.filesId.length < 5) return this.filesId.push(response.data.id)
      const fileName = response.data.path.split('/').pop();
      this.showNotification(this.$t('dropzone.limitedFiles', { nameFile: fileName }), 'error', -1)
    },
    addFiles(){
      this.$emit('postFileByExpensesRequest', {
        idExpenseRequest: this.editedItemRequest.id,
        filesId:this.filesId,
        user: this.userLogged,
        context: this,
      })
    },
    sendRequest(expensesRequest) {
      this.$emit('sendRequest', {
        context: this,
        expensesRequest,
      })
    },
    changeAdvance(event) {
      if (event === 'caja_chica') {
        this.editedItemRequest.petty_cash_type = 1
        this.editedItemRequest.advance = false
        this.editedItemRequest.amount_advance = 0
        this.editedItemRequest.showAdvance = false
      }
      if (event === 'anticipo') {
        let total = 0
        this.categoriesSelected.forEach((x) => {
          total +=
            x.amount !== undefined && x.amount !== undefined
              ? parseFloat(x.amount)
              : 0
        })
        this.editedItemRequest.petty_cash_type = 0
        this.editedItemRequest.advance = true
        this.editedItemRequest.amount_advance = total
        this.editedItemRequest.showAdvance = true
      }

      if (event === 'reembolso') {
        this.editedItemRequest.petty_cash_type = 0
        this.editedItemRequest.advance = false
        this.editedItemRequest.amount_advance = 0
        this.editedItemRequest.showAdvance = false
      }
    },
    changeDateEndCategoryExtension(items, item, index) {
      items[index].end_date = item.start_date
    },
    getAmountExtension(item, index) {
      if (item.price > 0 && item.quantity === 0) {
        item.quantity = 1
      }
      const amount = parseFloat(item.quantity) * parseFloat(item.price)
      this.editedItemRequest.extensions[0].categories[index].amount = amount
      if (this.editedItemRequest.extensions[0].is_advance) {
        let total = 0
        this.editedItemRequest.extensions[0].categories.forEach((e) => {
          total += e.amount !== undefined ? parseFloat(e.amount) : 0
        })
        this.editedItemRequest.extensions[0].amount_advance = total
        this.amountExtension = total
      } else {
        this.editedItemRequest.extensions[0].amount_advance = 0
      }
      this.descriptionExtensionDialog = false
    },
    addCategorieExtensions() {
      const categorieExt = {
        categories_id: null,
        price: 0,
        quantity: 0,
        comment: '',
        amount: 0,
        start_date: '',
        end_date: '',
        number_people: '0',
      }
      this.editedItemRequest.extensions[0].categories.push(categorieExt)
    },
    saveExtensions(index) {
      this.categoryExtensionRulesAlert = false
      if (this.$refs.formExtensions[index].validate()) {
        this.editedItemExtensions = true
      }
      if (this.editedItemRequest.extensions && this.editedItemRequest.extensions.length > 0 && this.editedItemRequest.extensions[0].categories.length === 0) {
        this.editedItemExtensions = false
        this.categoryExtensionRulesAlert = true
      }
    },
    sendExtensions() {
      this.$emit('saveExtensions', {
        context: this,
      })
    },
    cancelExtensions(index) {
      this.editedItemExtensions = false
    },
    calculateTotalExtensions(event) {
      if (event === 0) {
        this.editedItemRequest.extensions[0].amount_advance = 0
        return
      }

      if (event === 1) {
        let total = 0
        this.editedItemRequest.extensions[0].categories.forEach((e) => {
          const subtotal = e.quantity * e.price
          total += subtotal
        })
        this.editedItemRequest.extensions[0].amount_advance = total
      }
    },
    getTotalExtensions(item) {
      let total = 0
      item.categories.forEach((e) => {
        total += e.amount !== undefined ? parseFloat(e.amount) : 0
      })

      return total
    },
    calculateTotalExtensions(event) {
      if (event === 0) {
        this.editedItemRequest.extensions[0].amount_advance = 0
        return
      }

      if (event === 1) {
        let total = 0
        this.editedItemRequest.extensions[0].categories.forEach((e) => {
          const subtotal = e.quantity * e.price
          total += subtotal
        })
        this.editedItemRequest.extensions[0].amount_advance = total
      }
    },
    addExtension() {
      let current_date = this.editedItemRequest.end_date

      if (this.editedItemRequest.extensions.length > 0) {
        // const lastItemIndex = this.editedItem.extensions.length - 1
        // current_date = this.editedItem.extensions[lastItemIndex].end_date
        current_date = this.editedItemRequest.extensions[0].end_date
      }

      this.showBtnAddExtension = false
      const payload = {
        end_date: '',
        current_date,
        is_advance: 1,
        amount_advance: 0,
        status: '',
        categories: [
          {
            categories_id: null,
            price: 0,
            quantity: 0,
            comment: '',
            amount: 0,
            start_date: '',
            end_date: '',
            number_people: '0',
          },
        ],
      }

      this.editedItemRequest.extensions.unshift(payload)
    },
    getStatusSpanish(status) {
      if (status === 'CREATED') return 'Creado'
      if (status === 'APPROVED') return 'Aprobado'
      if (status === 'REJECTED') return 'Rechazado'
      if (status === 'IN_REVIEW') return 'En revisión'
    },
    closeDialogCashier() {
      this.cashierRelation = []
      this.dialogRelationsChashier = false
    },
    deleteRelation({ cashier, user_id }) {
      this.$emit('deleteRelation', {
        event: {
          context: this,
          cashier,
          user_id,
        },
      })
    },
    generateRelations(payload) {
      this.$emit('generateRelations', {
        event: {
          context: this,
          payload,
        },
      })
    },
    getRelations(cashier) {
      this.$emit('getRelations', {
        event: {
          context: this,
          cashier,
        },
      })
    },
    expenseItemsFilter() {
      this.sumaSubtotal = 0
      this.sumaDescuento = 0
      this.sumaTotal = 0
      this.filteredExpenseItems.forEach((value, index) => {
        this.sumaSubtotal +=
          value.subtotal != null ? parseFloat(value.subtotal) : parseFloat(0)
        this.sumaDescuento +=
          value.discount != null ? parseFloat(value.discount) : parseFloat(0)
        this.sumaTotal +=
          value.total != null
            ? parseFloat(value.total * value.exchange)
            : parseFloat(0)
      })
    },
    countryFilter(item, queryText, itemText) {
      const description = item.descripcion.toLowerCase()
      const abbr = item.c_Pais.toLowerCase()
      const searchText = queryText.toLowerCase()
      return (
        description.indexOf(searchText) > -1 || abbr.indexOf(searchText) > -1
      )
    },
    currencyFilter(item, queryText, itemText) {
      const description = item.descripcion.toLowerCase()
      const abbr = item.c_Moneda.toLowerCase()
      const searchText = queryText.toLowerCase()
      return (
        description.indexOf(searchText) > -1 || abbr.indexOf(searchText) > -1
      )
    },
    getSatFormaPago(value) {
      return this.satFormaPago.find((element) => element.c_FormaPago === value)
    },
    getSatMetodoPago(value) {
      return this.satMetodoPago.find(
        (element) => element.c_MetodoPago === value
      )
    },
    getCurrency(value) {
      return this.satMoneda.find((element) => element.c_Moneda === value)
    },
    getCountry(value) {
      return this.satPais.find((element) => element.c_Pais === value)
    },
    isPDF(data) {
      if (data !== null) {
        let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
        if (type === 'pdf') {
          return true
        } else {
          return false
        }
      }
    },
    openPDF() {
      var tab = window.open()
      tab.document.write(
        '<body style="margin: 0;"> <iframe src="' +
          this.dataURL +
          '" frameborder="0" style="margin: 0; padding: 0; border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;"</iframe></body>'
      )
    },
    viewItems(items) {
      this.editedItemNF = Object.assign({}, items)
      this.editedItemNF.gst_category_id = this.editedItemNF.gst_categories_id
      this.dialogNF = true
      this.loading = false
      this.disabled = false
      items.views = true
      if (items.gst_receipt_types_id === 2) {
        if (
          items.gst_expenses_items_files !== undefined &&
          items.gst_expenses_items_files !== null
        ) {
          if (items.gst_expenses_items_files.length > 0) {
            this.$store.dispatch('getFile', {
              event: {
                context: this,
                fileId: items.gst_expenses_items_files[0].files_id,
              },
            })
          }
        }
      }
    },
    viewItemsF(items) {
      if (items.gst_expenses_items_files.length > 0) {
        this.editedItemF = items
        this.$store.dispatch('readXmlToHtml', {
          event: {
            id: items.gst_expenses_items_files[0].files_id,
            context: this,
            type: 'viewItemsF',
          },
        })
      }
      items.views = true
    },
    getHistory(item) {
      this.histLoading = true
      this.histItem = item
      this.histItem.progress = []
      this.creatorExpense = item.created_by
      
      this.$emit('getHistory', { id: item.id, context: this })
      this.$emit('getWorkflowValidatorApprover', {
        user_id: item.user_id,
        context: this,
      })
      this.$emit('getExpensesValidators', { id: item.id, context: this })
      this.histDialog = true
    },
    getPendingValidators() {
      this.pendingValidators = this.validators
      this.histItem.progress.forEach((item) => {
        this.pendingValidators = this.pendingValidators.filter(
          (x) => x.validator.user_id !== item.user_id
        )
      })
    },
    filterHistory() {
      if (this.histItem.progress.length > 0) {
        this.histSteps.sented = this.histItem.progress.filter(
          (item) => item.status === 'Enviado'
        )
        this.histSteps.reviewed = this.histItem.progress.filter(
          (item) => item.status === 'Revisado'
        )
        this.histSteps.payable = this.histItem.progress.filter(
          (item) => item.status === 'Aprobado'
        )
        this.histSteps.paid = this.histItem.progress.filter(
          (item) => item.status === 'Pagado'
        )
        if (this.histSteps.payable.length > 0) {
          this.isApproved = true
        }
      }
    },
    showWorkflowDialog(item) {
      if(item.is_blue_voucher === 1 && !item.gst_expenses_items.some(x => x.file_attach.length > 0)) return this.workflowDialogValidate = true
      this.workflowDialog = true
      this.editedItem = Object.assign({}, item)
    },
    closeWorkflowDialog() {
      this.workflowDialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.$refs.form.resetValidation()
      this.loading = false
    },
    doStartWorkflow() {
      this.loading = true
      this.startWorkflow()
    },
    checkFiscal(items) {
      var isNull = false
      items.forEach((item) => {
        if (item.subtotal === null) {
          isNull = true
        }
      })
      if (isNull) {
        return true
      }
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        var count = 0
        if (item.gst_receipt_types_id === 1) {
          if (item.uuid !== null) {
            count += 0
          } else {
            count += 1
          }
        }
        if (count <= 0) {
          return false
        } else if (count > 0) {
          return true
        }
      }
    },
    detail(item, type) {
      let expenseId = null
      switch (type) {
        case 1:
          expenseId = item.id
          break;
        case 2:
          const gstExpense = item.gst_expense
          if (gstExpense && gstExpense.id) {
            expenseId = gstExpense.id
          }
          break;
      }
      if (expenseId) {
        this.$router.push('/expenses/' + expenseId)
      }
    },
    hasPermission() {
      if (this.userLogged.roles && this.userLogged.roles[0].name === 'ADMIN' ||
        this.userLogged.roles && this.userLogged.roles[0].name === 'EMPLOYEE') {
        return true
      } else {
        return false
      }
    },
    getLogged() {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    changeSort(header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    deleteItem(item) {
      this.editedIndex = this.expenses.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.removeDialog = true
    },
    removeItem() {
      this.loading = true
      this.delete()
    },
    closeRemove() {
      this.loading = false
      this.removeDialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    },
    close() {
      this.requestEditValidate = true
      this.loading = false
      this.errors = {}
      this.dialog = false
      this.dialogNF = false
      this.editedItemRequest = Object.assign({}, this.defaultItemRequest)
      this.dialogRequest = false
      this.dialogDeleteRequest = false
      this.$refs.formDialogRequest.resetValidation()
      if (this.$refs.dropzone !== undefined) this.$refs.dropzone.removeAllFiles()
      this.editedItemRequest.travel_type = Object.assign({}, this.defaultItemRequest.travel_type)
      this.editedItemRequest.fuelRequests = Object.assign({}, this.defaultItemRequest.fuelRequests)
      this.categoriesSelected = []
      this.editDates = true
      this.editProject = true
      this.editUserAssined = true
      this.editDescription = true
      this.editIsTravel = true
      this.editOrigin = true
      this.editDestination = true
      this.editTravelType = true
      this.editIsVehicle = true
      this.editCategories = true
      this.editAdvance = true
      this.editTotalAmount = true
      this.editApprovers = true
      this.cfdiHtml = null
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.$refs.form.resetValidation()
      this.$refs.formExpense.resetValidation()
      this.isDisabledPettyCash = false
      this.isDisabledRefund = false
      this.isDisabledAdvance = false
      this.isDisabledOkBlue = false
      this.isDisabledOkBlueEdit = false
      this.isDisabledAmexCard = false
      this.isPettyCash = false
      this.histDialog = false
      this.histSteps = { sented: [], reviewed: [], payable: [], paid: [] }
      this.editedItemRequest.is_travel = false
      this.editedItemRequest.is_vehicle = false
      this.editOrderNumber = true
      this.editedItemRequest.extensions = []
      this.showBtnAddExtension = true
      this.editedItemExtensions = false
      this.filesId = []
      this.dropzoneKey++;
      this.dropzoneOptions.maxFiles = 5
      this.dropzoneOptions.dictDefaultMessage = this.$t('dropzone.defaultMaxFiles', { amount: '5', size: '5', unit: 'MB', })
      this.status = undefined
      this.validators = []
      this.viewVoucherAmount = false
      this.type = 'refund'
      this.amountExtension = 0
      this.statusRequestEdit = ''
      this.selectMultiProject = false
      this.confirmSave = false
    },
    viewItem(item) {
      this.editedIndex = this.viatics.indexOf(item)
      this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
      this.editedItem.creation_date = new Date(item.creation_date)
        .toISOString()
        .substr(0, 10)
      let categories = []
      item.categories.forEach((x) => {
        let itm = {}
        itm.id = x.pivot.id
        itm.categories_id = x.pivot.categories_id
        itm.name = x.name
        itm.quantity = x.pivot.quantity
        itm.price = parseFloat(x.pivot.price)
        itm.amount = x.pivot.amount
        itm.comment = x.pivot.comment
        this.categoriesSelected.push(itm)
        categories.push(x.id)
      })
      if (item.gst_travel_type_id !== null) {
        this.editedItem.is_travel = true
        this.editedItem.fuelRequests = item.fuel_requests
      } else {
        this.editedItem.is_travel = false
      }
      this.statusRequestEdit = item.status
      this.editedItem.has_advance = item.advance
      this.editedItem.advance = item.amount_advance
      this.editedItem.amount_authorized = item.amount_authorized
      this.editedItem.categories = this.categoriesSelected
      this.editedItem.categories_id = categories
      this.editedItem.comment =
        item.validators.length > 0 ? item.validators[0].pivot.comment : null
      this.date =
        item.validators.length > 0 ? item.validators[0].pivot.date : null
      this.name =
        item.validators.length > 0 ? item.validators[0].user.name : null
      let validators = []
      if (item.validators.length > 0) {
        item.validators.forEach((x) => {
          let validator = {}
          let user = this.users.find((u) => u.id === x.user_id)
          validator.id = x.id
          validator.validators_id = x.pivot.validators_id
          validator.name = user !== undefined ? user.name : ''
          validators.push(validator)
        })
        this.editedItem.validators = validators
      } else {
        this.editedItem.validators = []
      }
      this.editedItem.validator_id = validators[0].validators_id
      this.editedItem.categories.forEach((e, index) => {
        e.start_date = item.categories[index].pivot.start_date.substr(0, 10)
        e.end_date = item.categories[index].pivot.end_date.substr(0, 10)
      })
      this.dialogRequest = true
    },
    disabledButtons(item) {
      this.isDisabledPettyCash = true
      this.isDisabledOkBlue = true
      this.isDisabledAdvance = true
      this.isDisabledRefund = true
      this.isDisabledAmexCard = true

      if (item.is_blue_voucher === 1 && item.petty_cash_type === 0) {
        this.type = 'okBlue'
        this.isDisabledOkBlue = false
        return
      } 
      
      if (item.petty_cash_type === 1) {
        this.type = 'pettyCash'
        this.isDisabledPettyCash = false
        this.isDisabledOkBlue = item.is_blue_voucher === 0
        this.isDisabledOkBlueEdit = item.id > 0
        return
      }  
      
      if (item.petty_cash_type === 2) {
        this.type = 'amexCard'
        this.isDisabledAmexCard = false
        this.isDisabledOkBlue = item.is_blue_voucher === 0
        this.isDisabledOkBlueEdit = item.id > 0
        return
      }

      if (item.advance !== '0.00') {
        this.type = 'advance'
        this.isDisabledAdvance = false
        return
      } 
      
      if (item.advance === '0.00' && item.petty_cash_type === 0 && item.is_blue_voucher === 0) {
        this.type = 'refund'
        this.isDisabledAdvance = false
        this.isDisabledRefund = false
        return
      }
    },
    editItem(item) {
      this.disabledButtons(item)
      this.editedIndex = this.expenses.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.user.small_box = this.employees.find(x => x.id === item.user.id).small_box
      this.editedItem.isVoucherAmount = this.editedItem.is_blue_voucher
      this.viewVoucherAmountCheck()
      this.selectMultiProject = item.has_multiprojects === 1
      this.dialog = true
    },
    save() {
      this.post()
      if (this.$refs.form.validate()) {
       
        this.loading = true

        if (this.editedIndex > -1) {
          this.put()
        } else {
          this.post()
        }
      }
    },
    saveValidate() {
      if(this.selectMultiProject && this.editedItem.project_list.length === 1 && this.editedItem.project_list.find(x => x === this.editedItem.project_id)) return this.showNotification(this.$t('general.selectMultiProjects'), 'error', -1)
      
      this.editedItem.has_advance = this.type

      if(this.editedItem.id === null || (this.editedItem.id > 0 && this.editedItem.gst_expenses_items.length === 0)) return this.saveReservation()
      
      return this.confirmSave = true
    },
    saveReservation() {
      if(!this.$refs.formExpense.validate()) return

      this.editedItem.has_multiprojects = this.selectMultiProject

      if(!this.selectMultiProject) this.editedItem.project_list = []

      if(this.selectMultiProject && this.editedItem.project_list.length > 0 && !this.editedItem.project_list.find(x => x === this.editedItem.project_id)) this.editedItem.project_list.unshift(this.editedItem.project_id)
      
      if(this.selectMultiProject && this.editedItem.project_list.length === 0) return this.showNotification(this.$t('general.selectMultiProjects'), 'error', -1) 

      if((this.type === 'pettyCash' || this.type === 'amexCard')  && this.editedItem.isVoucherAmount && (this.editedItem.voucher_amount === undefined || this.editedItem.voucher_amount === 0 || this.editedItem.voucher_amount === "" || this.editedItem.voucher_amount === "0.00")) return this.showNotification(this.$t('expenses.blueVoucher.addAmount'), 'error', -1)

      if(this.type === 'okBlue' && (this.editedItem.voucher_amount === undefined || this.editedItem.voucher_amount === 0 || this.editedItem.voucher_amount === "" || this.editedItem.voucher_amount === "0.00")) return this.showNotification(this.$t('expenses.blueVoucher.addAmount'), 'error', -1);
      
      this.loading = true
      
      if(this.editedItem.id === null){
        this.$emit('postReservation', {
        item: this.editedItem,
        user: this.editedItem.user_id,
        context: this,
      })
      }
      else{
        this.$emit('putReservation', {
        item: this.editedItem,
        user: this.editedItem.user_id,
        context: this,
      })
      }
    },
    get() {
      this.$emit('get', {
        user_id: this.userLogged.roles[0].name !== 'ADMIN' ? this.userLogged.id : null,
        company_id: this.userLogged.roles[0].name !== 'ADMIN' ? null : this.userLogged.company[0].id,
        gst_expenses_status_id : this.gst_expenses_status_id,
        context: this,
      })
    },
    getByStatus(status, tags){
      if(this.disabledTag === true) return
      this.loadingItems = true
      this.statusTagCheckReservation = tags
      this.disabledTagCheckReservation = true

      this.gst_expenses_status_id = status

      if(tags === 'REJECTED') {
          this.$emit('getByStatusReject', {
          user_id: this.userLogged.roles[0].name !== 'ADMIN' ? this.userLogged.id : null,
          company_id: this.userLogged.roles[0].name !== 'ADMIN' ? null : this.userLogged.company[0].id,
          gst_expenses_status_id : 1,
          context: this,
        })
        return
      }
      
      

      this.$emit('getByStatus', {
        user_id: this.userLogged.roles[0].name !== 'ADMIN' ? this.userLogged.id : null,
        company_id: this.userLogged.roles[0].name !== 'ADMIN' ? null : this.userLogged.company[0].id,
        gst_expenses_status_id : status,
        context: this,
      })
    },
    post() {
      this.$emit('post', {
        item: this.editedItem,
        user: this.editedItem.user,
        context: this,
      })
    },
    put() {
      this.$emit('put', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this,
      })
    },
    delete() {
      this.$emit('delete', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this,
      })
    },
    startWorkflow() {
      this.$emit('startWorkflow', {
        context: this,
        item: this.editedItem,
      })
    },
    refresh() {
      this.$emit('refresh', {
        user_id:
          this.userLogged.roles[0].name !== 'ADMIN' ? this.userLogged.id : null,
        company_id:
          this.userLogged.roles[0].name !== 'ADMIN'
            ? null
            : this.userLogged.company[0].id,
        context: this,
      })
    },
    onTabChanged() {
      // this.tabActive = this.tabs.length - 1
    },
    openDialogRequest() {
      this.$refs.formDialogRequest.resetValidation()
      this.editedItemRequest.user.id = this.userLogged.id
      this.editedItemRequest.user.name = this.userLogged.name
      this.editedItemRequest.has_advance = 'reembolso'
      this.editedItemRequest.advance = false
      this.editedItemRequest.showAdvance = false
      this.editedItemRequest.order_number = null
      this.editedItemRequest.fuelRequests = [
        {
          gst_vehicle_id: null,
          description: null,
          initial_milleage: 0,
          final_milleage: 0,
          fuel_liters: 0,
          final_liters: 0,
        },
      ]
      this.dialogRequest = true
    },
    sendExpenseView() {
      if(this.assigned_user_id !== this.userLogged.id) {
        this.addExpenseDialog = false
        this.$router.push('/reservations/checks')
        return
      }
      
      this.$router.push('/expenses')
      
    },
    closeAddExpenseDialog() {
      this.addExpenseDialog = false
      this.refresh()
    },
    // DECRAPED
    // getRequest(status) {
    //   this.status = status === undefined ? status : 'CREATED'
    //   // this.loadingItems = true
    //   this.loadingItemsReservations = true
    //   this.$emit('getRequest', {
    //     context: this,
    //   })
    // },
    getRequestTags(status, tag) {
      if(this.disabledTag === true) return
      this.disabledTag = true
      this.activeTabReserva = tag
      this.viatics = []
      this.statusTag = status
      this.loadingItemsReservations = true
      this.$emit('getRequest', {
        context: this,
      })
    },
    addCategorie() {
      const item = {}
      item.start = false
      item.end = false
      item.categories_id = null
      item.price = 0
      item.quantity = 0
      item.amount = 0
      // item.name = null
      item.start_date = null
      item.end_date = null
      item.comment = ''

      this.categoriesSelected.push(item)
    },
    getAmount(item,index) {
      //let selectedItem = []
      //selectedItem = this.categoriesSelected.find(
        //(x) => x.categories_id === item.categories_id
      //)
      this.categoriesSelected.forEach((x) => {
        let amount = 0
        if (x !== undefined) {
          if (x.price > 0 && x.quantity === 0) {
            x.quantity = 1
          }
          amount =
            parseFloat(x.quantity) * parseFloat(x.price)
          x.amount = amount
        }
      })      
      this.descriptionDialog = false
    },
    changeDateEndCategory(item, index) {
      this.categoriesSelected[index].end_date = item.start_date
    },
    showDescriptionDialogExtense(status, item, index) {
      this.commentExtense.index = index
      this.commentExtense.comment = item.comment
      this.commentExtense.disabled =
        status === 'APPROVED' || status === 'REJECTED' || status === 'IN_REVIEW'
      this.descriptionExtensionDialog = true
    },
    saveDescriptionDialogExtense() {
      this.editedItemRequest.extensions[0].categories[
        this.commentExtense.index
      ].comment = this.commentExtense.comment
      this.descriptionExtensionDialog = false
    },
    deleteCategorie(index) {
      this.categoriesSelected.splice(index, 1)
    },
    downloadRequest(type) {
      this.loadingDownload = type
      this.$emit('downloadRequest', {
        context: this,
        item: this.editedItemRequest,
        type,
      })
    },
    downloadRequestByComprobacion(item) {
      this.loadingDownload = true
      this.$emit('downloadRequest', {
        context: this,
        expensesRequest: item.travel_expenses_request.id,
        folio: item.travel_expenses_request.folio,
      })
    },
    confirmDelete(item) {
      this.editedItemRequest = Object.assign(
        {},
        JSON.parse(JSON.stringify(item))
      )
      this.dialogDeleteRequest = true
    },
    deleteRequest() {
      this.loading = true
      this.$emit('deleteRequest', {
        expensesRequestD: this.editedItemRequest.id,
        context: this,
      })
    },
    editItemRequest(item) {
      this.getAmountExtensions(item)
      this.editedItemRequest = Object.assign({}, this.defaultItemRequest)
      this.requestEditValidate = false
      this.editedIndex = this.viatics.indexOf(item)
      this.editedItemRequest.id = item.id
      this.editedItemRequest.status = item.status
      this.editedItemRequest.folio = item.folio
      this.editedItemRequest.user = item.user
      this.editedItemRequest.assigned_user_id = item.assigned_user_id
      this.editedItemRequest.start_date = new Date(item.start_date).toISOString().substr(0, 10)
      this.editedItemRequest.end_date = new Date(item.end_date).toISOString().substr(0, 10)
      this.editedItemRequest.project_id = item.project_id
      this.editedItemRequest.order_number = item.order_number
      this.editedItemRequest.description = item.description
      // this.editedItemRequest = Object.assign(
      //   {},
      //   JSON.parse(JSON.stringify(item))
      // )
      this.editedItemRequest.creation_date = new Date(item.creation_date).toISOString().substr(0, 10)
      let categories = []
      item.categories.forEach((x) => {
        let itm = {}
        itm.id = x.pivot.id
        itm.categories_id = x.pivot.categories_id
        itm.name = x.name
        itm.quantity = x.pivot.quantity
        itm.price = parseFloat(x.pivot.price)
        itm.amount = x.pivot.amount
        itm.comment = x.pivot.comment
        this.categoriesSelected.push(itm)
        categories.push(x.id)
      })

      this.editedItemRequest.origin = item.origin
      this.editedItemRequest.destination = item.destination
      if (item.gst_travel_type_id !== null) {
        this.editedItemRequest.is_travel = true
        this.editedItemRequest.travel_type.id = item.travel_type.id
      } else {
        this.editedItemRequest.is_travel = false
      }
      /**Leer datos del vehículo */
      if (item.fuel_requests.length > 0) {
        this.editedItemRequest.fuelRequests = item.fuel_requests
        this.editedItemRequest.is_vehicle = true
        this.editedItemRequest.fuelRequests[0].final_liters = this
          .editedItemRequest.fuelRequests[0].final_liters
          ? this.editedItemRequest.fuelRequests[0].final_liters
          : 0
        this.editedItemRequest.fuelRequests[0].final_milleage = this
          .editedItemRequest.fuelRequests[0].final_milleage
          ? this.editedItemRequest.fuelRequests[0].final_milleage
          : 0
        this.editedItemRequest.fuelRequests[0].fuel_liters = this
          .editedItemRequest.fuelRequests[0].fuel_liters
          ? this.editedItemRequest.fuelRequests[0].fuel_liters
          : 0
        this.editedItemRequest.fuelRequests[0].initial_milleage = this
          .editedItemRequest.fuelRequests[0].initial_milleage
          ? this.editedItemRequest.fuelRequests[0].initial_milleage
          : 0
        this.editedItemRequest.fuelRequests[0].description = this
          .editedItemRequest.fuelRequests[0].description
          ? this.editedItemRequest.fuelRequests[0].description
          : null
      }
      if (item.fuel_requests.length === 0) {
        this.editedItemRequest.is_vehicle = false
        // this.editedItemRequest.fuelRequests = []
      }

      const typeRadio = this.hasAdvanceRadio(item)

      this.statusRequestEdit = item.status
      this.status = item.status
      this.editedItemRequest.has_advance = typeRadio
      this.editedItemRequest.advance = item.amount_advance
      this.editedItemRequest.amount_advance = item.amount_advance
      this.editedItemRequest.amount_authorized = item.amount_authorized
      this.editedItemRequest.categories = this.categoriesSelected
      this.editedItemRequest.categories_id = categories
      this.editedItemRequest.comment =
        item.validators.length > 0 ? item.validators[0].pivot.comment : null
      this.date =
        item.validators.length > 0 ? item.validators[0].pivot.date : null
      this.name =
        item.validators.length > 0 ? item.validators[0].user.name : null
      let validators = []
      if (item.validators.length > 0) {
        item.validators.forEach((x) => {
          let validator = {}
          let user = this.users.find((u) => u.id === x.user_id)
          validator.id = x.pivot.id
          validator.validators_id = x.pivot.validators_id
          validator.name = user !== undefined ? user.name : ''
          validators.push(validator)
        })
        this.editedItemRequest.validators = validators
      } else {
        this.editedItemRequest.validators = []
      }
      this.editedItemRequest.validator_id = validators[0].validators_id
      this.editedItemRequest.categories.forEach((e, index) => {
        e.start_date = item.categories[index].pivot
          && item.categories[index].pivot.start_date
          && item.categories[index].pivot.start_date.substr(0, 10)
        e.end_date = item.categories[index].pivot
          && item.categories[index].pivot.end_date
          && item.categories[index].pivot.end_date.substr(0, 10)
      })
      this.editedItemRequest.extensions = []
      // Leer ampliaciones
      if (item.extensions.length > 0) {
        // const extensions = item.extensions[0]
        const extensions = []

        item.extensions.forEach((e) => {
          const data = e
          const categories = data.categories.map((e) => {
            if (!e.pivot) {
              return e
            }
            return {
              id: e.id,
              name: e.name,
              core_company_id: e.core_company_id,
              default: e.default,
              categories_id: e.pivot.categories_id,
              id: e.pivot.id,
              number_people: e.pivot.number_people,
              price: e.pivot.price,
              quantity: e.pivot.quantity,
              comment: e.pivot.comment,
              start_date: new Date(e.pivot.start_date)
                .toISOString()
                .substr(0, 10),
              end_date: new Date(e.pivot.end_date).toISOString().substr(0, 10),
              amount: e.pivot.amount,
            }
          })

          data.categories = categories

          extensions.push(data)
        })

        this.editedItemRequest.extensions = extensions
      }

      this.requestEditValidate = true
      this.dialogRequest = true
      this.editedItemRequest.attachments = item.attachments
      if(this.editedItemRequest.attachments.length > 0) {
        // // incrementa la clave para forzar la recreación del componente
        this.dropzoneKey++;
        this.dropzoneOptions.maxFiles = this.editedItemRequest.attachments.length > 4 ? 0 : (5 - this.editedItemRequest.attachments.length) 
        this.dropzoneOptions.dictDefaultMessage = this.$t('dropzone.defaultMaxFiles', { amount: this.dropzoneOptions.maxFiles, size: '5', unit: 'MB', }),
        
        this.editedItemRequest.attachments.forEach((item) =>{
          this.$store.dispatch('getFile', { event: { context: this, fileId: item.file_id }})
          item.dataURL = this.dataURL
        })
        
      }
    },
    getAmountExtensions(items){
      if(items.extensions.length > 0){
        let amountValidate = items.advance === 0 ? this.getMontoAdvance(items) : (items.amount_authorized || items.amount_advance)
        let total = items.extensions.reduce((sum, item) => {
          return sum + (item.amount_authorized !== null ? item.amount_authorized : item.amount_advance);
        }, 0);

        return this.amountExtension =  Number(amountValidate) + Number(total)
      }
      this.amountExtension = 0
    },
    getMontoAdvance(expense){
      return expense.categories.reduce((accumulator, item) => {
        return accumulator + (item.pivot.quantity * item.pivot.amount);
      }, 0);
    },
    saveRequest() {
      this.categoryRulesAlert = false
      let SelectedCategories = this.categoriesSelected
      if (!this.editedItemRequest.validator_id) return  this.showNotification(this.$t('viatics.validators'), 'error', -1)
      if (SelectedCategories.length === 0) {
        this.categoryRulesAlert = true
        return
      }
      if (this.editedIndex > -1) {
        if (this.$refs.categoriesForm[0]) {
          if (!this.$refs.categoriesForm[0].validate()) return
        } else {
          if (!this.$refs.categoriesForm.validate()) return
        }
      } else {
        if (!this.$refs.categoriesForm.validate()) return
      }
      this.errors = {}
      if (this.$refs.formDialogRequest.validate()) {
        this.loading = true
        this.actionsLoading = true
        if (this.editedIndex > -1) {
          this.putRequest()
        } else {
          this.postRequest()
        }
      }
    },
    postRequest() {
      this.editedItemRequest.categories = this.categoriesSelected
      this.$emit('postRequest', {
        item: this.editedItemRequest,
        user: this.userLogged,
        context: this,
      })
    },
    putRequest() {
      if (!this.editedItemRequest.is_vehicle) {
        this.editedItemRequest.fuelRequests = []
      }
      this.editedItemRequest.categories = this.categoriesSelected
      this.$emit('putRequest', {
        item: this.editedItemRequest,
        index: this.editedIndex,
        context: this,
      })
    },
    createExpense(item) {
      this.editedItem.extensions = item.extensions
      this.editedItem.start_date = item.start_date
      this.editedItem.end_date = item.end_date
      this.editedItem.project_id = item.project_id
      this.editedItem.user = item.user_assigned ? item.user_assigned : item.user
      this.editedItem.user_id = item.assigned_user_id ? item.assigned_user_id : item.user_id
      this.assigned_user_id = this.editedItem.user_id 
      // this.editedItem.viatic_request_id = item.viatic_request_id
      this.editedItem.viatic_request_id = item.id
      this.editedItem.description = item.description
      this.editedItem.status_advance = item.advance
      this.editedItem.amount_authorized = item.amount_authorized
      this.type = this.getTypeExpense(item)
      
      if(item.advance === 1){
        const amountAuthorized = this.advanceAuthorizedCalculate(item, item.amount_authorized)
        this.editedItem.advance = amountAuthorized
        this.type = 'advance'
      }
      
      this.dialog = true
    },
    getTypeExpense(item){
      if (item.is_imported_expense === 1) return 'travelExpense'
      if (item.petty_cash_type === 0 && item.is_blue_voucher) return 'okBlue' 
      if (item.petty_cash_type === 1) return 'pettyCash' 
      if (parseFloat(item.advance) > 0) return 'advance'
      if (parseFloat(item.advance) <= 0 && item.petty_cash_type === 0) return 'refund'
    },
    hasAdvanceRadio (item) {
      let type = ''
      if (item.petty_cash_type === 1) {
        type = 'caja_chica'
      } else if (parseFloat(item.advance) > 0) {
        type = 'anticipo'
      } else if (item.petty_cash_type === 0 && parseFloat(item.advance) <= 0) {
        type = 'reembolso'
      }
      return type
    },
    advanceCalculate (item, amount_advance) {
      const extensions = item.extensions
      const amountAdvance = amount_advance
      let total = 0
      if (extensions && extensions.length > 0) {
        const sum = extensions
                    .filter(extension => extension.status === "APPROVED")
                    .reduce((a, b) => +a + +b.amount_advance, 0);
        total = +sum + +amountAdvance
      } else {
        total = amountAdvance
      }
      return total
    },
    advanceAuthorizedCalculate (item, amount_authorized) {
      const extensions = item.extensions
      const amountAdvance = amount_authorized
      let total = 0
      if (extensions && extensions.length > 0) {
        const sum = extensions.reduce((a, b) => +a + +b.amount_authorized, 0);
        total = +sum + +amountAdvance
      } else {
        total = amountAdvance
      }
      return total
    },
    extensionNumberGenerator (item, extensions) {
      let number = 0
      if (item && item.id) {
        const filterValidationId = extensions.filter(e => e && !e.id)
        let elementPos = extensions.findIndex(obj => obj.id == item.id)
        if (filterValidationId.length === 0) {
          number = elementPos + 1
        } else {
          number = elementPos
        }
      } else {
        number = extensions.length
      }
      return number
    },
    deleteExtension (index, categories) {
      categories.splice(index, 1)
      if (this.editedItemRequest.extensions[0].is_advance) {
        let total = 0
        this.editedItemRequest.extensions[0].categories.forEach((e) => {
          total += e.amount !== undefined ? parseFloat(e.amount) : 0
        })
        this.editedItemRequest.extensions[0].amount_advance = total
      } else {
        this.editedItemRequest.extensions[0].amount_advance = 0
      }
    },
    extensionHandlerValidation (editedItem) {
      let disabled = false
      const extensions = editedItem.extensions
      if (extensions.length > 0) {
        const inReview = (ext) => ext.status === 'IN_REVIEW';
        let isInReview = extensions.some(inReview)
        disabled = isInReview
      }
      return disabled
    },
    getAcuse(id) {
      this.$emit('getAcuse', {
        id,
        context: this,
      })
    },
    downloadExcelReport({ id }) {
      this.$emit('downloadExcelReport', {
        context: this,
        id,
      })
    },
    viewVoucherAmountCheck(){
       this.viewVoucherAmount = (this.type === 'pettyCash' || this.type === 'amexCard') && this.editedItem.isVoucherAmount
    },
    viewExpenseReject(expenses_progress){
      return expenses_progress.some(expense => expense.status === "Regresado")
    },
    viewExpenseRejectMessage(expenses_progress){
      const expenseProgress =  expenses_progress
        .filter(expense => expense.status === "Regresado")
        .reduce((prev, current) => (prev.id > current.id) ? prev : current)

      return `${this.$t('general.commentFrom')} ${expenseProgress.user.name} "${expenseProgress.comment}"`
    }
  },
}
</script>

<style>

.text__color {
  color: #1e3c72;
}

.custom-row-color {
    background-color:rgba(137, 119, 240, 0.322);
}

.hist-steps {
  background-color: #63b225 !important;
}

.custom-bg {
  background-color: rgba(221, 27, 27, 0.267);
}
.text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/reservations.component.vue